import React, {Component} from 'react';
import {
    View,
    StatusBar,
    Image,
    TextInput,
    Text,

    BackHandler,
    Alert,
    TouchableOpacity,
    Platform,
    KeyboardAvoidingView,
    ScrollView, Dimensions, StyleSheet, Keyboard, I18nManager, ActivityIndicator
} from "react-native"

import {verticalScale, moderateScale, scale} from "../../../../tools/Scaling";
import {AsyngStorageClass} from "../../../../tools/AsyngStorageClass";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import Colors, {colorPrimary} from "../../../../tools/Colors";
import HMTextView from "../../../../customviews/HMTextView";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import HMActionBarSatia from "../../../../customviews/HMActionBarSatia";
import i18n from "../../../../I18n/i18n";
import HMTextInputEfects from "../../../../customviews/HMTextInputEfects";
import {typeExport} from "../../../../redux/store/type";
import {Tools} from "../../../../tools/Tools";
import PathFile from "../../../../assets/PathFile";
import store from "../../../../redux/store";
import Steps from "../../../../customviews/steps/Steps";
import * as NavigationService from "../../../../redux/NavigationService";
import HMImageView from "../../../../customviews/HMImageView";
import HMListCheckBox from "../../../../customviews/HMListCheckBox";

import HMDatePicker from "../../../../customviews/HMDatePicker";
import HMIcon from "../../../../customviews/HMIcon";
import HMSelectInput from "../../../../customviews/HMSelectInput";
import Toast from "../../../../customviews/toast";
import axios from "axios";
import ListServiceSatiaScreen from "../../main/listService/ListServiceSatiaScreen";
import HMModal from "../../../../customviews/modal/HMModal";
import PaySatiaScreen from "../../main/pay/action/ActionPaySatiaScreen";

const firstIndicatorConfigs = {
    stepIndicatorSize: moderateScale(30),
    currentStepIndicatorSize: moderateScale(40),
    separatorStrokeWidth: moderateScale(3),
    currentStepStrokeWidth: moderateScale(4),
    separatorFinishedColor: '#4aae4f',
    separatorUnFinishedColor: '#a4d4a5',
    stepIndicatorFinishedColor: '#4aae4f',
    stepIndicatorUnFinishedColor: '#a4d4a5',
    stepIndicatorCurrentColor: '#ffffff',
    stepIndicatorLabelFontSize: moderateScale(15),
    currentStepIndicatorLabelFontSize: moderateScale(15),
    stepIndicatorLabelCurrentColor: '#000000',
    stepIndicatorLabelFinishedColor: '#ffffff',
    stepIndicatorLabelUnFinishedColor: 'rgba(255,255,255,0.5)',
    labelColor: '#666666',
    labelSize: moderateScale(12),
    currentStepLabelColor: '#4aae4f',
};
// const {width, height} = Dimensions.get('window');

let container = null


let NameInputAlert = null;
let MoarefRef = null;
let ServiceRef = null;
let TypeInternet = null;

let RegulationContent = "\"قرارداد ارايه خدمات اينترنت پرسرعت\"\n" +
    "ماده 1: تعاريف\n" +
    "1-1- کمیسیون: کمیسیون تنظیم مقررات ارتباطات\n" +
    "1-2- سازمان: سازمان تنظیم مقررات و ارتباطات رادیویی\n" +
    "1-3- سرویس‌دهنده: شركت ساتیا ری ارتباط که از این ‌پس در این قرارداد \"شركت\" نامیده می شود.\n" +
    "1-4- مشترك (سرویس‌گیرنده): هر شخص حقیقی و یا حقوقی است که به ‌عنوان کاربر نهایی به‌موجب این قرارداد از خدمات موضوع قرارداد استفاده می‌نماید.\n" +
    "1-5- دوره اشتراك: مدت زمان سرويس انتخابي كه مشترك بر اساس تعرفه اعلامي از سوي شركت در چارچوب مصوبات كميسيون هزينه آن را پرداخت مي كند و از زمان دايري سرويس آغاز مي شود.\n" +
    "1-6- پنل کاربری، حساب کاربری: به معنی درگاه خدمات برای مشترک بوده که تمامی اطلاع‌رسانی‌ها و اعمال تغییرات روی سرویس مشترک از طریق آن به آدرس امکان‌پذیر است.\n" +
    "1-7- شبکه شرکت: كليه تجهيزات و خطوط ارتباطي که تحت مالکیت شرکت مي باشد.\n" +
    "1-8- ترافیک دوره : ميزان اطلاعات قابل مبادله، توسط مشترك در طول يك دوره كه اين ترافيك در بازه زماني سرويس قابل استفاده بوده و ترافيك باقيمانده قابل انتقال به دوره بعد نمي باشد.\n" +
    "1-9- دايري سرويس: تحويل و راه اندازي سرويس مشترك و برقراري ارتباط با شبكه شركت مي باشد.\n" +
    "1-10- رانژه: آماده كردن خط مشترك به منظور برقراري ارتباط تلفن مشترك با شبكه شركت مي باشد.\n" +
    "1-11- مکان دریافت خدمت: محلی که شرکت خدمات خود را در آن نقطه به مشترک تحویل می دهد و قابل تغییر نمی باشد .\n" +
    "1-12- اقامتگاه اصلی: به معنای مشخصات آخرین نشانی محل سکونت، اعلام شده از سوی مشترک به شرکت می باشد.\n" +
    "1-13- نشانی IP: نشانی پروتکل اینترنت، برچسب عددی است که به تجهیزات شبکه های رایانه ای اختصاص پیدا می کند و به منظور اتصال بین گره های شبکه استفاده می شود.\n" +
    "1-14- نشانی هاي عمومي IP‌: نشاني هاي IP كه در شبكه جهاني اينترنت قابل مسيريابي هستند.\n" +
    "1-15- نشانی هاي خصوصي IP: بازه ای از نشانی هاي IPاست كه براي شبكه‌هاي خصوصي (مانند شبكه داخلي سازمان ها و شبكه ملي اطلاعات) در نظر گرفته شده است.\n" +
    "1-16- شماره تماس: شماره تماس جهت ارتباط با پشتیبانی به‌صورت 24 ساعته و در 7 روز هفته مي باشد.\n" +
    "1-17- سرویس: انواع سرویس های غیر حجمی که از طریق سایت شرکت به نشانی www.fanava.net قابل مشاهده می باشد.\n" +
    "1-18- ترافيك آستانه استفاده مصرف منصفانه: حداکثر حجم مصرفی تعیین شده از سوی شركت در هریک از سرعت های تعیین شده، به نحوي كه ترافيك داخلي حداقل دو برابر ترافيك بين الملل است.\n" +
    "1-19- سرعت پايه: سرعتي است كه پس از اتمام حجم مصرف منصفانه مشترك در يك ماه سرويس دهي بر مبناي آن براي هر دو نوع ترافيك داخل و بين الملل ادامه خواهد يافت و حداقل ميزان تعيين شده براي آن سرعت 128 كيلو بيت بر ثانيه است.\n" +
    "1-20- ترافیک داخلی: هر ترافیک با میزبانی در داخل کشور است.\n" +
    "ماده 2: موضوع قرارداد\n" +
    "عبارت است از:\n" +
    "برقراری اتصال دو طرفه نامتقارن غير اختصاصي به شبکه جهانی اینترنت از طریق شبکه شرکت و ارايه خدمات پشتيباني مرتبط با آن بر اساس نوع سرويس درخواستي مندرج در فرم درخواست سرويس كه جزء لاينفك اين قرارداد مي باشد.\n" +
    "تامین پهنای باند اینترنتی اختصاصي، با سرعت دریافت ----------- مگا بیت بر ثانیه (Mbps -----) و ارسال ----------- مگا بیت بر ثانیه (Mbps-------) به همراه IP----------- و تحويل آن در مكان دريافت خدمت و ارايه خدمات پشتيباني مرتبط با آن.\n" +
    "تبصره1: در طول مدت قرارداد و در صورت نیاز مشترک و وجود امکانات و پس از تسویه آخرین صورتحساب های ارسالی، مشترک می تواند کتباً تقاضای کاهش یا افزایش موضوع قرارداد را بنماید که در این صورت الحاقیه جداگانه ای با توافق طرفين تنظیم خواهد گردید.\n" +
    "تبصره2: ارتقاء پهنای باند از طریق بستر Wirelessمنوط به بررسی و تایید قابلیت تجهیزات ارتباطی موجود توسط کارشناسان فنی شركت می باشد.\n" +
    "ماده 3: مدت‌ زمان قرارداد\n" +
    "مدت زمان قرارداد در فرم درخواست سرويس مشخص شده است و با اولين اتصال به شبکه شرکت بر حسب ساعت و دقيقه شروع مي شود\n" +
    "تبصره 1: در خدمات اینترنت پرسرعت ADSLمشترک باید حداکثر ظرف مدت 72 ساعت پس از اعلام آمادگی تحويل سرویس به مشترک و تحویل نام کاربری و کلمه عبور و اطلاعات لازم از سوی شركت به مشترک، ارتباط با شبکه شركت را برقرار نماید. در صورت عدم انجام این امر در زمان اشاره شده توسط مشترک، مبنای زمان دايري سرویس از زمان اعلام آمادگی تحویل سرویس از سوی شركت لحاظ خواهد شد.\n" +
    "تبصره2: در خدمات اینترنت پرسرعت ADSLدر صورتی که مشترک درخواست اعزام کارشناس نصب و تحویل حضوری سرویس را داشته باشد، شركت حداکثر ظرف مدت 72 ساعت پس از اعلام رانژه خط تلفن و اعلام آمادگی تحویل سرویس به مشترک، سرویس را به صورت حضوری نصب و راه اندازي کرده و نام کاربری و کلمه عبور و اطلاعات لازم را نيز تحویل می دهد، در صورتی که مشترک در این مدت شرایط و محیط رابرای نصب و مراجعه حضوری کارشناس آماده ننماید، زمان دايري سرویس 72 ساعت پس از زمان اعلام آمادگی تحویل سرویس از سوی شرکت در نظر گرفته می شود.\n" +
    "تبصره 3: در خدمات اينترنت پرسرعت مبتنی بر فنآوری WiFi، شرکت حداکثر ظرف مدت 72 ساعت پس از درخواست مشترک و اعلام آمادگی تحویل سرویس به مشترک، سرویس را به صورت حضوری نصب، راه اندازی و دایر کرده و تحویل می دهد و شركت متعهد است شروع قرارداد را از تاريخ امضاء صورتجلسه نصب توسط مشترک محاسبه نمايد.\n" +
    "تبصره 4: هشدار پايان زمان دوره سرويس طبق قرارداد حداقل 72 ساعت قبل از اتمام زمان پايان دوره، توسط شركت به صورت ارسال پست الکترونيکي يا پيامك به مشترک اطلاع رساني مي شود. مشترك می تواند در این مدت نسبت به تمدید قرارداد و پرداخت هزینه های آن اقدام نماید. در صورت عدم ارايه درخواست تمدید توسط مشترک، قرارداد فی ما بین پایان‌یافته تلقی شده و سرویس جمع‌آوری می‌شود و راه‌اندازی مجدد سرویس منوط به وجود امکانات فنی و پرداخت هزینه نصب مجدد خواهد بود.\n" +
    "تبصره 5: براي مشتركيني كه در مكان اجاره اي به سر مي برند، شرکت تنها تا پایان مهلت زمان اجاره قرارداد می بندد و پس از آن در صورت ارایه اجاره نامه جديد و يا تمديد اجاره نامه قبلي از سوی مشترک به شرکت نسبت به تمدید این قرارداد یا انعقاد قرارداد جدید با مشترک اقدام می شود.\n" +
    "ماده 4: مبلغ قرارداد\n" +
    "مشترک بايد قبل از آغاز بهره برداري از خدمات مندرج در ماده دو در ابتداي هر ماه یا دوره هزينه خدمات را مطابق تعرفه های مصوب کمیسیون و براساس سرویس درخواستی بپردازد.\n" +
    "4-1- مبلغ کل قرارداد براساس سرويس درخواستي مندرج در فرم درخواست سرويس در مصوبات شماره 1 جلسه شماره 237مورخ 22/03/95 و شماره 266 مورخ 21/08/1396 و شماره 268 مورخ 03/10/96 و شماره 268 مورخ 03/10/96 کمیسیون و يا ساير مصوباتي است كه در آينده تصويب مي شود با احتساب ماليات بر ارزش افزوده ---------- ریال، براي كل دوره جمعا ----------- ریال مي باشد كه مشترک موظف است در ابتدای هر ماه يا دوره ظرف مدت 5 روز از زمان صدور صورتحساب، مبلغ ---------- ریال را از طریق درگاه پرداخت الکترونیکی در پنل کاربری واریز و یا به‌صورت نقد پرداخت نماید.\n" +
    "تبصره 1: مشترك در صورت عدم دريافت صورتحساب مي بايست موضوع را كتبا به شركت اعلام نمايد.\n" +
    "تبصره 2: مبالغ مندرج در بند 1 ماده 4 صرفاً مربوط به ارايه سرويس درخواستي در طول مدت قرارداد حاضر می باشد و تامين و تهيه تجهيزات و دستگاه های مورد نياز مربوطه از جمله مودم و آنتن و ... و همچنين هزينه نصب و راه اندازی بعهده مشترک بوده كه صورتحساب آن بصورت جداگانه صادر مي شود.\n" +
    "4-2- هزینه راه‌اندازی تجهیزات مشترک اینترنت پرسرعت ADSL: درصورتی‌که مشترک نیازمند حضور نماینده شركت برای نصب سرویس در محل موردنظر باشد، باید هزینه راه‌اندازی تجهیزات انتهایی را علاوه بر هزینه اشتراک مطابق نرخ شركت در چارچوب مصوبات کمیسیون به مبلغ 150000 ریال در زمان عقد قرارداد پرداخت نماید.\n" +
    "4-3- هزینه دایری و تخلیه مشترک اینترنت پرسرعت ADSL: مطابق مصوبه شماره 1 جلسه شماره 237 مورخ 22/03/95 کمیسیون، هزینه رانژه مخابرات (دایری/ تخلیه) برابر120.000 ریال بوده و این هزینه علاوه بر هزینه اشتراک و راه‌اندازی اتصال، فقط یک‌بار در هنگام عقد قرارداد از مشترکین دریافت می‌شود. بدیهی است در صورت عدم پرداخت هزینه مذکور از سوی مشترک این هزینه در هنگام درخواست جمع‌آوری از سوی شركت مطالبه و مشترک ملزم به پرداخت آن قبل از جمع‌آوری است.\n" +
    "تبصره 3: مطابق مصوبات جاری کشور، مالیات بر ارزش‌افزوده به کلیه مبالغ هزینه‌های مذکور اضافه‌شده و مشترک ملزم به پرداخت آن برای هر دوره اشتراک است.\n" +
    "تبصره 4: در صورت نیاز، مشترک می‌تواند نسبت به خرید ترافیک اضافی بر اساس مصوبات کمیسیون اقدام نماید.\n" +
    "تبصره 5: با پرداخت هزینه اشتراک، این قرارداد خود به ‌خود برای دوره‌ای که حق اشتراک آن پرداخت ‌شده، تمدید می‌گردد.\n" +
    "تبصره 6: درصورت اتمام ترافیک آستانه مصرف منصفانه، پس از اطلاع‌رسانی به مشترک، سرعت سرویس به سرعت پایه تغییر می یابد و بازگشت آن به سرعت اولیه منوط به اتمام دوره یک ماهه برقراری سرویس و شروع مجدد ترافیک مصرف منصفانه دوره یک ماه بعدی و یا خرید ترافیک مازاد بصورت پیش پرداخت از طریق پنل کاربری مشترک مي باشد.\n" +
    "ماده 5: تعهدات شركت\n" +
    "5-1-شركت ارايه یک یا چند مورد خدمات یا تجهیزات را به خرید یک یا چند مورد دیگر مشروط نمی‌نماید.\n" +
    "5-2- شركت متعهد می‌شود که به همان ترتیب اعلامی در تبلیغات و بازاریابی خود قراردادها را تنظیم کند.\n" +
    "5-3- شركت قوانین و مقررات مصوب مراجع ذی‌صلاح قانونی مربوط به ارايه خدمات موضوع این قرارداد را از طریق درج در وب‌سایت در دسترس مخاطبان و مشترکین قرار می‌دهد.\n" +
    "5-4-شركت متعهد می‌شود تمهیدات لازم را برای رعایت تعهداتSLA در هنگام عملیات شبکه را پیش‌بینی کند و بااطلاع قبلی (حداقل 48 ساعت قبل) زمان Down Time را تعیین کند. عملیات Down Time در زمان‌های کم ترافیک ( ساعت 2 تا 6 صبح) انجام می‌شود و تعداد آن در ماه حداکثر یک ‌بار است.\n" +
    "5-5-شركت متعهد به ارائه و اجرای توافقنامه سطح خدمات (SLA) مطابق ضوابط مصوبه شماره 177 (و ساير مصوبات جديد مرتبط بعدي) کمیسیون بوده و تمام بندهای توافقنامه سطح خدمات (SLA) از زمان امضای قرارداد و تحویل سرویس قابل‌اجرا مي-باشد.\n" +
    "5-6- شركت متعهد می‌شود تا پایان دوره اشتراک خدمت انتخابی، تغییری در شرایط مقرر در قرارداد نخواهد داد؛ مگر اینکه بر اساس اعلام سازمان مجبور به اعمال تغییرات باشد که در این مورد نیز شرایط جدید باید به اطلاع مشترک برسد و تصمیم‌گیری در خصوص ادامه یا فسخ قرارداد در اختیار مشترک باشد. (( برای سرویس دهی به یک سری مشترکین هزینه گزاف پورت به مخابرات پرداخت می شود و امکان دادن حق فسخ بدلیل تغییر قوانین سازمان نیست. ))\n" +
    "5-7-شركت در قبال تصمیمات مراجع ذیصلاح و تغییرات در قوانین و مقررات مؤثر بر این قرارداد مسئولیتی ندارد؛ مگر اینکه بعدها اعمال‌ نفوذ ناروای آن در تصویب احکام مورد نظرش به اثبات برسد.\n" +
    "5-8-چنانچه به تشخیص شركت، اصلاحات یا ایجاد تغییرات در متن قرارداد ضروری باشد، پس از تائید سازمان، حداقل 14 روز قبل از لازم‌الاجرا شدن نسبت به تحويل نسخه كتبي و يا الكترونيكي به مشترک اقدام نموده و مشترک در طی مدت مذکور می‌توانداعتراضات خود را به‌صورت کتبی و یا الکترونیکی از طریق ایمیل ،یا نمابر به شماره به شركت اعلام نماید.\n" +
    "تبصره 1: در خصوص قرارداد هاي قبلي، شركت موظف به كسب رضايت مشتركين جهت اعمال تغييرات است.\n" +
    "5-9- شركت متعهد می‌شود تحت هیچ شرایطی به‌جز در مواردی که قانون و مقررات معین می‌کند، مشترکین را از دسترسی به خدمات موضوع این قرارداد محروم یا محدود نکند.\n" +
    "5-10- شركت متعهد می‌شود چنانچه آسیبي مشتركين را از طریق خدمات موضوع قرارداد تهدید کند و از این رخداد آگاه باشد، نسبت به آگاه‌سازی مشترکین و ارايه رهنمودهای پیشگیرانه به آن‌ها اقدام کند.\n" +
    "5-11- شركت موظف به حفظ محرمانگی داده‌ها و اطلاعات مشترکین و ارتباطات و حریم خصوصی مشترکین است و متعهد می‌شود به مشترکین جهت صیانت از داده‌ها و اطلاعات شخصی شان متناسب با خدمات ارتباطی و فن‌آوری اطلاعات و آسیب‌های احتمالی ناشی از تهدیدها اطلاع‌رسانی کافی را به عمل آورد.\n" +
    "5-12-شركت متعهد می‌شود که اعمال هرگونه نظارت بر کارکردهای خدمات، موجب دسترسی غیرمجاز به داده‌ها و ارتباطات شخصی مشترکین نیست و رعایت مقررات قانونی ناظر به این حوزه الزامی است.\n" +
    "5-13- مشخصات و نرخ خدمات بايد به نحو مناسب و با جزييات كامل، به‌طور رايگان به اطلاع مشتركين رسانده شود.\n" +
    "5-14- شركت متعهد به ارايه خدمات دسترسی به اینترنت به مشترک مطابق موضوع قرارداد بوده و در صورت درخواست مشترک مبنی بر نصب و راه‌اندازی خدمت، شركت موظف به نصب و راه‌اندازی تجهیزات انتهایی مشترک است. هزینه راه‌اندازی تجهیزات انتهایی طبق مصوبه کمیسیون از مشترک اخذ و صورت‌جلسه تحویل خدمات موضوع قرارداد با مشترک تنظیم می‌شود.\n" +
    "5-15- شركت متعهد است موضوع این قرارداد را در مکان دریافت خدمت و در درگاه خروجی رادیو، روتر يا مودم ( قبل از شروع شبکه مشترک) تحویل نماید و مسئولیتی در قبال تحویل اینترنت بر روی شبکه مشترك ندارد.\n" +
    "5-16- شركت موظف است داده‌ها و اطلاعات مربوط به شاخص‌های کیفیت خدمات را تا شش ماه پس از پایان قرارداد مشترکين نگهداری کنند تا امکان پاسخگویی به ادعاهای مطرح‌شده از سوی آن‌ها مبنی بر نبود یا کاستی کیفیت خدمات را داشته باشد .\n" +
    "5-17- شركت متعهد است بی‌وقفه، به‌صورت بیست‌وچهار(24) ساعت در شبانه‌روز و هفت(7) روز در هفته، خدمات موضوع قرارداد را فراهم نماید و امکانات پشتيباني تلفنی از طریق شماره و پاسخگويي به مشتركين خود را به‌صورت شبانه‌روزی و در تمام ايام هفته و ايام تعطيل فراهم كند.\n" +
    "تبصره 2: پشتیبانی حضوری و رفع عیوب فنی که نیاز به عملیات فیزیکی در مراکز مخابراتی یا محل مشترک (ADSL) يا محل نصب تجهيزات (WiFi) دارند، در ساعات اداری قابل‌ بررسی و حل است.\n" +
    "5-18- شرکت متعهد می گردد در صورت بروز اختلال و یا قطع ارتباط حسب گزارش مشترک، در اسرع وقت نسبت به رفع اشکال اقدام نماید.\n" +
    "5-16- شرکت هيچ گونه تعهد و مسئوليتي در صورت قطع خط مشترک، عمليات کابل برگردان و تبديل شدن خط تلفن به حالت فيبرنوري توسط مخابرات ندارد.\n" +
    "5-17- شرکت هيچ گونه مسئوليتي در قبال سيم کشي داخل ساختمان، دستگاه تلفن مرکزي (سانترال)، رايانه و تجهيزات آن، کابل کشي و غيره سمت مشترک ندارد.\n" +
    "ماده 6: تعهدات مشترک\n" +
    "6-1- مشترک متعهد می‌شود با آگاهی کامل از بهای خدمات و نحوه پرداخت هزینه‌ها نسبت به‌گزینش آن‌ها اقدام کند و به مواعد مقرر در قرارداد پایبند باشد .\n" +
    "6-2- مشترک متعهد می‌شود کلیه قوانین و مقررات جمهوری اسلامی ایران مرتبط با موضوع قرارداد و دستورالعمل‌هایی که از سوی مراجع ذی‌ربط صادر و ابلاغ‌شده و از طریق پایگاه اطلاع‌رسانیشركت یا سایر مبادی ذی‌ربط اطلاع‌رسانی شده است را رعایت نماید .\n" +
    "6-3- مشترک متعهد می‌شود از واگذاری امکانات و تجهیزات متعلق به شركت به غیر خودداری نماید. در غیر این صورت دارنده پروانه مجاز به فسخ خدمات است .\n" +
    "6-4-هرگونه واگذاری خطوط و لینک‌ها و مدارات ارتباطی پهنای باند و سایر امکانات و خدمات ارائه‌شده به آن‌ها به غیر و خارج از روال انتقال امتیاز توسط شركت و همچنین توزیع تمام یا بخشی از آن‌هابه‌صورت عمومی به سایرین (فعالیت مشابه شركت هاي اپراتوري) به هر شکل و تحت هر عنوان ممنوع بوده و مشترکین صرفاً مجاز به استفاده از خطوط و خدمات مذکور توسط خود و یا کارمندان خود (در زمان اشتغال به کار یا مأموریت سازمانی) می‌باشند.\n" +
    "تبصره 1: ارايه سرویس به محصلین و یا دانشجویان دانشگاه‌ها و سایر مؤسسات آموزشی در زمان حضور آن‌ها درمکان محل تحصیل و منوط به رعایت تمامی موارد بلامانع است.\n" +
    "تبصره 2: در صورت توزیع درون‌سازمانی خطوط و خدمات ارائه‌شده ، ثبت مشخصات هویتی وCDR وLOG فعالیت کاربران و ذخیره آن برای مدت حداقل یک سال جهت ارائه به مراجع ذی‌صلاح ضروری است.\n" +
    "6-5- مسئولیت عواقب هرگونه استفاده سوء و مغایر با قوانین و مقررات از خطوط و خدمات ارائه‌ شده صرفاً بر عهده مشترکین و صاحب‌امتیازآن‌هااست.\n" +
    "6-6- مشترکین مجاز به انتقال ترافیک خطوط تلفن از بسترهای دیتا و اینترنت واگذارشده نمی‌باشند.\n" +
    "تبصره 3: این محدودیت خطوط تلفن داخلی (PBX) سازمان‌ها و شركت ها و مؤسسات را در محدوده ساختمان و شبکه محلی در برنمی‌گیرد.\n" +
    "6-7- در صورت نیازمندی برخی از مشترکین حقوقی جهت توزیع اینترنت در مکان‌های عمومی (از قبیل پارک‌ها و مراکز تفریحی و فرودگاه‌ها، پایانه‌های مسافربری و ... ) با استفاده از بسترWIFI و یا هر روش دیگر لازم است این اقدام تحت مسئولیت و مديريت شركت به متولیان اماکن فوق صورت پذیرفته و در مراحل طراحی و اجرا نیز هماهنگی لازم بین شركت جهت تأمین پیوست کنترلی، اعمال سیاست های امنیتی و همچنین نحوه احراز هویت، ثبت و ذخیره مشخصات وLOG فعالیت کاربران به عمل آید.در غیر این صورت این عمل تخلف بوده و کلیه مسئولیت ها و تبعات آن به عهده مشترک خواهد بود.\n" +
    "6-8- بدیهی است شركت می‌تواند در صورت مشاهده و اطلاع از موارد تخطی از مفاد بندهای 6-5 تا 6-7 توسط مشترک نسبت به صدور اخطار با مهلت 10 روزه جهت رفع موارد تخلف اقدام نموده و در صورت عدم رفع تخلف ملزم به قطع خطوط و توقف ارائه سرویس تا زمان رفع موارد تخلف و همچنین معرفی مشترک خاطی به مراجع ذیصلاح است.\n" +
    "6-9- مشترک متعهد می‌شود در صورت تغییر مشخصات تماس (نشاني، شماره تلفن و آدرس پست الکترونیکی)، اطلاعات جدید خود را به دارنده پروانه اطلاع دهد، در صورت عدم اطلاع‌رسانی و بروز هرگونه مشکلی در برقراری تماس با مشترک ، مسئولیت عدم اطلاع از مواردی که متضمن اطلاع‌رسانی است، بر عهده مشترک خواهد بود.\n" +
    "6-10- مشترك موظف است پس از اولين ارتباط با شبكه شركت ، نسبت به تغيير رمز ورود سرويس خود اقدام نمايد و حفاظت از سیستم‌ها و اطلاعات سمت مشترک بر عهده خودش است و مشترک باید از نام کاربری و رمز عبور به نحو مناسب نگهداری نماید.\n" +
    "6-11-كليه سرويس ها داراي نشانی‌های عمومي IPبه‌صورت متغير (Dynamic) است و در صورت نياز به سرویس‌های دارای نشانی‌های خصوصی IP در هر زمان با پرداخت هزينه مربوطه و وجود امکانات، امکان‌پذیر است.\n" +
    "6-12- به‌منظور تکریم ارباب‌رجوع تمامی مکالمات برقرارشده با مشترک ضبط می‌شود و درصورتی‌ که مشاهده رفتار نابهنجار و یا الفاظ خارج از عرف جامعه از سوی کارکنان شركت و یا مشترک دو طرف حق مستند قراردادن مکالمه ضبط‌ شده و پیگیری موضوع مطابق قوانین کشور را دارند.\n" +
    "6-13-شرکت متعهد است در صورت دريافت درخواست مشترک مبنی بر تغییر طرح خدمات، درخواست وی را در هر زمان از دوره ی اعتبار قرارداد بررسی کرده و در صورت وجود امکانات و براساس تعرفه شرکت مندرج در سایت و در چارچوب مصوبات کمیسیون به تغییر طرح خدمات اقدام کند.\n" +
    "6-14- مشترک متعهد می گردد که از تجهیزات امانی به بهترین وجه نگهداری نماید و تجهیزات را در پایان یا فسخ قرارداد به شرکت عودت نماید.\n" +
    "ماده 7: شرایط فسخ قرارداد\n" +
    "7-1- مشترک در صورت تمایل به انصراف از دریافت خدمات، می‌بایستی با ارائه درخواست بصورت كتبي يا از طريق پنل کاربری خود به فسخ قرارداد اقدام نماید و شركت مکلف است حداکثر ظرف مدت یک هفته از تاریخ اعلام فسخ مشترک، نسبت به انجام کلیه مراحل فسخ و فسخ قرارداد با وی اقدام نماید. بدیهی است در صورت درخواست فسخ یک‌طرفه از سوی مشترک قبل از پایان قرارداد هزینه پرداختی مربوط به این قرارداد به مشترک عودت داده نخواهد شد. همچنین فسخ و یا اتمام قرارداد به هر دلیل، به‌هیچ‌وجه رافع مسئولیت‌های مشترک در خصوص تعهدات وی در طول مدت‌زمان اعتبار نبوده و باید پاسخگوی موارد استفاده غیرمجاز در طول مدت‌زمان قرارداد فسخ‌شده باشد.\n" +
    "7-2- چنانچه شركت نتوانسته باشد ظرف یک هفته از تاریخ انعقاد قرارداد نسبت به ارائه خدمات با معیارها و مفاد موردنظر این قرارداد ازجمله تعهدات SLA اقدام نماید، مشترک می‌تواند نسبت به اعلام فسخ قرارداد و اخذ هزینه اقدام نماید و شركت مکلف است ظرف یک هفته از تاریخ اعلام فسخ مشترک ، نسبت به تسویه‌حساب با وی اقدام نماید.(مرجع اینکه شرکت نتوانسته طبق sla سرویس دهی نماید کجاست ؟ )\n" +
    "7-3- در صورت ارائه هرگونه درخواستی از سوی مشترک خدمات اینترنت پرسرعت ADSL مبنی بر تغییر در وضعیت تلفن ثابتی که ارتباط موضوع قرارداد بر روی آن دایر شده است (اعم از تغییر مالکیت، تغییر شماره، تغییر مکان و ...) و عدم امکان برقراری ارتباط در شرایط جدید، مشترک می‌تواند نسبت به درخواست فسخ اقدام نماید. بدیهی است مسئولیت مالی و حقوقی ناشی از موضوع قرارداد تا زمان ارائه درخواست فسخ و جمع‌آوری ارتباط به عهده مشترک است.\n" +
    "7-4- مشترک خدمات اینترنت پرسرعت ADSL ( مستأجر ، صاحب خط) حق فسخ یک‌طرفه و جمع‌آوری رانژه خط موضوع قرارداد، از روی تجهیزات شركت و از طریق شرکت مخابرات را ندارد.\n" +
    "ماده 8 :رسیدگی به شکایت‌ها\n" +
    "مشترك می‌تواند در صورت داشتن شكايت، به وب‌سایت شركت به آدرس www.195.ir مراجعه و شكايت خود را در سامانه شکایات ثبت نمايد. در صورت بروز هرگونه اختلاف بین طرفین قرارداد و عدم رفع مشکل از طریق مذاکره و گفتگوی دوجانبه، مشترک می-تواند موضوع را به سازمان از طریق مراجعه به سایت www.195.ir یا تماس با تلفن گویای 195 یا شماره پیامک 600195 و یا آدرس ایمیل 195@ict.gov.irمنعکس و اقدام به ثبت شکایت نماید. لازم به ذکر است پس از ثبت درخواست از طریق سايت شركت و سازمان، سیستم یک شماره پیگیری در اختیار مشترک قرارداده که مشترک می‌تواند از طریق لینک‌های مذکور پیگیری‌های لازم را انجام دهد.\n" +
    "ماده 9: وضعیت اضطراری\n" +
    "9-1- وضعیت اضطراری پیش‌بینی‌شده و پیش‌بینی‌نشده تنها در صورتی از شركت سلب مسئولیت می‌کند که فرا ارادی باشد.\n" +
    "9-2- در صورت بروز وقفه غیرمجاز در ارائه خدمات، شركت می‌بایستبی‌درنگ، کلیه اقدامات ضروری برای اعاده دسترسی به خدمات و به حداقل رساندن پیامدهای عدم دسترسی مشترکین به خدمت را انجام دهد.\n" +
    "9-3- در صورت بروز وضعیت اضطراری، شركت هم‌زمان با انجام کلیه اقدامات ضروری می‌بایست نسبت به اطلاع‌رسانی آنی به مشتركين اقدام نماید.\n" +
    "9-4- عدم امکان انجام تعهدات موضوع قرارداد توسط شركت که به‌موجب وقوع بلاياي طبيعي که ناشي از عدم رعايت استانداردهاي ايمني در تأسيس و نصب و بهره‌برداری از تجهيزات شبکه باشد، مشمول اين ماده نمي‌شود و به‌عنوان قصور از تعهدات شركت تلقي خواهد شد.\n" +
    "ماده10- کلیات قرارداد\n" +
    "12-1-اين قرارداد در 10 ماده و در 2 نسخه تنظيم، امضاء و مبادله گرديد كه هر نسخه حكم واحد را دارا مي باشد.\n" +
    "12-2-كليه مفاد قرارداد به رؤيت طرفين رسيده و طرفين خود را متعهد به اجرای آن می دانند و امضاء ذيل صفحات به منزله قبول و تائيد كليه مفاد اين قرارداد مي باشد.";

export default class InformationSatiaScreen extends Component {

    constructor(props) {
        super(props)
        container = this;

        let sliderWidth = 1;
        let itemWidth = 1;
        let slideHeight = 1;
        let widthOriginal = Platform.OS === "web" ? 1 : typeExport._WIDTH;

        if (Platform.OS === "web") {
            let viewportWidth = document.body.clientWidth;
            let viewportHeight = document.body.clientHeight;
            widthOriginal = document.body.clientWidth;

            slideHeight = viewportHeight * 0.35;


            sliderWidth = viewportWidth;
        }
        let {Account} = store.getState().reducerSplashSatiaScreen;
        MoarefRef = props.route.params && props.route.params.m ? props.route.params.m : null;
        ServiceRef = props.route.params && props.route.params.s ? props.route.params.s : null;
        TypeInternet = props.route.params && props.route.params.t ? props.route.params.t : null;
        this.state = {
            widthOriginal: widthOriginal,

            itemWidth: itemWidth,
            sliderWidth: sliderWidth,
            slideHeight: slideHeight,

            visibleModal: false,
            currentPage: 0,
            selectStatusLine: false,
            selectStatusAgreement: false,
            PhoneNumberForReview: null,
            NationalCode: '',
            First_name: '',
            Last_name: '',
            Mobile: '',
            address: '',
            PostalCode: '',
            ShSh: '',
            IdentifierCode: Account ? Account.Mobile : '',
            Email: '',
            Education: '',
            BirthDay: '',
            checked: false,
            indexSelectGender: 1,
            isVisible: false,

            ServiceType: null,
            resultRegulationContent: null,
            resultCheckPhone: null,
            resultRegister: null,
            resultAllRegister: null,
            isLoadingService: false,
            indexSelectCheckBoxPersonalityType: 1,
            indexSelectCheckBoxGender: 1,
            typeSelectCheckBoxPersonalityType: "HA",
            typeSelectCheckBoxGender: "MR",
            Modem: null,
            listModem: [
                {
                    id: 1, value: 'مودم tplink858', label: 'مودم tplink858',
                }, {
                    id: 2, value: 'مودم huawi 55', label: 'مودم huawi 55',
                },
            ],
            listEducation: [
                {
                    id: 1, value: 'سیکل', label: 'سیکل',
                },
                {
                    id: 2, value: 'دیپلم', label: 'دیپلم',
                }, {
                    id: 3, value: 'فوق دیپلم', label: 'فوق دیپلم',
                },
                {
                    id: 4, value: 'لیسانس', label: 'لیسانس',
                },
                {
                    id: 5, value: 'فوق لیسانس', label: 'فوق لیسانس',
                },
                {
                    id: 6, value: 'دکترا', label: 'دکترا',
                },

            ],
            listTypeInternet: [
                {

                    height:
                        "3.8",
                    width:
                        "3.2",
                    id:
                        "64",
                    link:
                        "5",
                    //  card: true, login: true, link_type: "RSS",

                    name:
                        "اینترنت ADSL",
                    // title: " اینترنت ADSL",

                    thumbnail:
                        "https://my.satia.co/images/register/adsl_net.png",
                    type:
                        "A",

                },
                // {
                //
                //     height:
                //         "3.8",
                //     width:
                //         "3.2",
                //     id:
                //         "64",
                //     link:
                //         "5",
                //     //card: true, login: true, link_type: "RSS",
                //
                //     name:
                //         "اینترنت WIRELESS",
                //     // title: "اینترنت WIRELESS",
                //
                //     thumbnail:
                //         "https://my.satia.co/images/register/wifi_net.png",
                //     type: "W",
                //
                // },
                /*
                      {

                          height:
                              "3.8",
                          width:
                              "3.2",
                          id:
                              "64",
                          link:
                              "5",
                          //  card: true, login: true, link_type: "RSS",

                          name:
                              "اینترنت HOTSPOT",
                          //  title: "اینترنت HOTSPOT",

                          thumbnail:
                              "http://partak.satiaisp.com/images/register/hot_net.png",
                          type:
                              "3",

                      },*/

            ],

            selectInternetType: TypeInternet,

        }

        props.callServiceRefresh();


    }

    connectToServer() {
        let {resultCheckPhone, selectInternetType,} = this.state;

        this.setState({isLoadingService: true,});

        let token = store.getState().reducerSplashSatiaScreen.token;

        const formData = new FormData();
        formData.append('lang', i18n.locale);
        formData.append('token', store.getState().reducerSplashSatiaScreen.token);
        formData.append('serial', ServiceRef);


        formData.append('resultCheckPhone', JSON.stringify(resultCheckPhone));
        formData.append('InternetType', resultCheckPhone && resultCheckPhone.Type ? resultCheckPhone.Type : (selectInternetType));
        formData.append('Township', resultCheckPhone && resultCheckPhone.TownshipRef ? resultCheckPhone.TownshipRef : "1",);
        formData.append('SerialMdfGroup', resultCheckPhone && resultCheckPhone.MdfGroup ? resultCheckPhone.MdfGroup : null);
        formData.append('CustomerGroup', "1");
        formData.append('typeRegister', true);


        axios({
            method: 'post',
            url: typeExport._baseUrlSatia + "services/serviceBySerial",
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

        })
        //   axios.post(typeExport._baseUrlSatia + "ibs/littlemore", formData, config)
            .then(async response => {

               // console.log("response", response)
                let data = response.data;
                this.setState({
                    ServiceType: data.status && data.result ? data.result : null,
                    isLoadingService: false,
                })

            })
            .catch((e) => {
                console.log(e)
                this.setState({isLoadingService: false})

            })
    }

    componentDidMount() {
        if (TypeInternet){
            //alert("jhdfsh")
            this.nextStep()
        }


        BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);
    }

    componentWillUnmount() {
        BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
    }

    handleBackPress = () => {
        this.goBack(); // works best when the goBack is async
        return true;
    }

    goBack() {

        this.props.navigation.pop();


        // switch (this.props.navigation.state.params.type_login) {
        //
        //     case "fav":
        //         this.props.navigation.navigate("MainScreen");
        //         break;
        // }

    }

    componentWillReceiveProps(props) {
        /*     if (propss.results != null) {
                 //   this.loadingButton.showLoading(false);

                 if (propss.results.status == true) {
                     this.props.callServiceSetToken(propss.results.user.token);
                     this.props.callServiceSetUser(propss.results.user),

                         this.setInfoUser(
                             propss.results.user.token,
                             propss.results.user.Password,
                             propss.results.user.name,
                             this.props.navigation.state.params.mobile,
                         )
                 } else {
                     alert(propss.results.message)

                 }
             }*/
    }

    async setInfoUser(token, Password, name, mobile) {

        let value1 = await AsyngStorageClass.setInfoUser(token, Password, name);
        let value2 = await AsyngStorageClass.setInfoUserMobile(mobile);

        if (value1 & value2) {

            this.props.navigation.pop();

            switch (this.props.navigation.state.params.type_login) {
                case "changeInfo":
                    this.props.navigation.navigate("ChangeInformationSatiaScreen");
                    break;

                default:
                    this.props.navigation.navigate("SplashScreen", {refreshOfLogin: true});
                //this.props.navigation.pop();
            }
        } else {
            this.props.navigation.pop();
            alert(i18n.t('constant.Try_again'))
        }
    }

    getData() {
        let {First_name, Last_name, Mobile, address, checked, NationalCode} = this.state
        let paramss = {
            "_operation": typeExport._Registration,
            "mode": typeExport._RegisterMode,
            "lang": i18n.locale,
            "First_name": First_name,
            "Last_name": Last_name,
            "Mobile": Mobile,
            "NationalCode": Tools.persianToEnglish(NationalCode),
            // "NationalCode":NationalCode,
            "Address": address,
            "private": checked ? "1" : "0",
            "gender": this.state.indexSelectGender,
            "mobile": this.props.navigation.state.params.mobile ? this.props.navigation.state.params.mobile : this.state,
            "token_fb": this.props.DataSplashScreen.token_fb,

        };
        this.props.callService(
            typeExport.urlGetInformationSatiaScreen,
            // `?mobile=${this.props.navigation.state.params.mobile}&name=${this.state.First_name}&Password=${this.state.Password}`,
            paramss,
            typeExport.TypegetDataInformationSatiaScreen,
            "POST"
        );

    }

    checkInput() {
        let {First_name, Last_name, Mobile, address, NationalCode} = this.state;

        let National_code = Tools.persianToEnglish(NationalCode)
        if (First_name.trim().length <= 1) {
            Alert.alert(
                i18n.t('constant.message'),
                i18n.t('constant.Check_First_name'),
                [
                    // {text: 'Ask me later', onPress: () => {}},
                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                    {
                        text: i18n.t('constant.ok'), onPress: () => {
                        }
                    },
                ],
                {cancelable: true}
            )
            //    alert("نام و نام خانوادگی را وارد نمایید")
        } else {
            if (Last_name.trim().length <= 1) {
                Alert.alert(
                    i18n.t('constant.message'),
                    i18n.t('constant.Check_Last_name'),
                    [
                        // {text: 'Ask me later', onPress: () => {}},
                        // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                        {
                            text: i18n.t('constant.ok'), onPress: () => {
                            }
                        },
                    ],
                    {cancelable: true}
                )
                //    alert("نام و نام خانوادگی را وارد نمایید")
            } else {


                if (Mobile.trim().length < 6) {
                    Alert.alert(
                        i18n.t('constant.message'),
                        i18n.t('constant.checkMobile'),
                        [
                            // {text: 'Ask me later', onPress: () => {}},
                            // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                            {
                                text: i18n.t('constant.ok'), onPress: () => {
                                }
                            },
                        ],
                        {cancelable: true}
                    )
                    //    alert("نام و نام خانوادگی را وارد نمایید")
                } else {
                    if (address.trim().length < 6) {
                        Alert.alert(
                            i18n.t('constant.message'),
                            i18n.t('constant.checkaddress'),
                            [
                                // {text: 'Ask me later', onPress: () => {}},
                                // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                {
                                    text: i18n.t('constant.ok'), onPress: () => {
                                    }
                                },
                            ],
                            {cancelable: true}
                        )
                        //    alert("نام و نام خانوادگی را وارد نمایید")
                    } else {
                        if (National_code == null || National_code == '') {
                            this.getData();
                        } else {

                            Tools.check_national_code(National_code) ?
                                this.getData()
                                :
                                Alert.alert(
                                    i18n.t('constant.message'),
                                    i18n.t('constant.Check_NationalCode'),
                                    [
                                        // {text: 'Ask me later', onPress: () => {}},
                                        // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                        {
                                            text: i18n.t('constant.ok'), onPress: () => {
                                            }
                                        },
                                    ],
                                    {cancelable: true}
                                )
                        }

                    }
                }
            }
        }

    }

    _changeText(name, text) {
        this.setState({
            [name]: text
        });
    }

    _changeTextFirst_name(text) {
        this.setState({
            First_name: {
                value: text,
                error: ''
            }
        });
    }

    _changeTextNationalCode(text) {
        this.setState({
            NationalCode: {
                value: text,
                error: ''
            }
        });
    }

    _changeTextLast_name(text) {
        this.setState({
            Last_name: {
                value: text,
                error: ''
            }
        });
    }

    _changeTextInviteCode(text) {
        this.setState({
            address: {
                value: text,
                error: ''
            }
        });
    }

    _changeTextMobile(text) {
        this.setState({
            Mobile: {
                value: text,
                error: ''
            }
        });
    }

    _changeTextAddress(text) {
        this.setState({
            address: {
                value: text,
                error: ''
            }
        });
    }

    _checkDisplay(field) {
        return {display: field === '' ? 'none' : 'flex'}
    }

    NameButtonNext() {
        let {selectStatusLine, currentPage} = this.state;
        switch (currentPage) {

            case 1:
                return selectStatusLine ? "ادامه ثبت نام" : i18n.t('constant.CheckPhoneLine');

            case 3:
                return i18n.t('constant.AcceptRules')

            case 4:
                return "ثبت نام";
            case 5:
                return "پرداخت";

            default:
                return i18n.t('constant.next')
        }
    }

    componentWillMount() {
        let {listTypeInternet,selectInternetType} = this.state;
        if (!selectInternetType && listTypeInternet && listTypeInternet.length === 1) {
            this.setState({
                selectInternetType: listTypeInternet[0].type
            })
        }
        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.body.clientWidth;
                let viewportHeight = document.body.clientHeight;


                const slideHeight = viewportHeight * 0.35;


                const sliderWidth = viewportWidth;

                container.setState({
                        widthOriginal: document.body.clientWidth,
                        widthV: document.body.clientWidth > 600 ? document.body.clientWidth / 2.05 : document.body.clientWidth,

                        //    widthV: document.body.clientWidth,
                        heightV: document.body.clientHeight,
                        // itemWidth: itemWidth,
                        sliderWidth: sliderWidth,
                        slideHeight: slideHeight,
                    },
                )


            })

    }

    render() {

        let checkLogin = (store.getState().reducerSplashSatiaScreen.token)
        // let textButtonNext = this.state.currentPage === 4 ? i18n.t('constant.SubmitRequest') : this.state.currentPage === 1 ? i18n.t('constant.AcceptRules') : i18n.t('constant.next')
        let textButtonNext = this.NameButtonNext()
        let width = (Platform.OS === "web" ? (this.state.widthOriginal > 600 ? 600 : this.state.widthOriginal) : typeExport.WIDTH);
        let {PhoneNumberForReview, NationalCode, First_name, Last_name, Mobile, address, PostalCode, ShSh, IdentifierCode, Email, Education, BirthDay, typeSelectCheckBoxPersonalityType, typeSelectCheckBoxGender, ServiceType} = this.state;

        return (
            <View style={{position: 'relative', flex: 1}}>


                {/* <HMImageBackground

                />
*/}
                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{flex: 1,}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <View style={{flex: 1,}}>
                            <HMActionBarSatia
                                props={this.props} statusBarTransparent
                                text={i18n.t('Information.title')}

                                //  text={i18n.t('constant.Information')}
                                menu={checkLogin}
                                back
                                headerVisibility more_menu
                                onBackPress={() => this.props.navigation.pop()}

                            />
                            <View

                                style={styles.stepIndicator}>

                                <Steps
                                    configs={firstIndicatorConfigs}
                                    current={this.state.currentPage}
                                    // reversed={true}
                                    //  labels={this.pageDataArray}

                                    count={5}
                                />
                            </View>
                            <View style={{flex: 1, backgroundColor: Colors.white}}>
                                <View style={{flex: 1}}>

                                    {
                                        this.renderStep(width)
                                    }
                                </View>

                                {/*       <TouchableOpacity
                                    onPress={()=>  this.setState({

                                        //     address: !this.state.checked ? "من در رستوران غذا را تحویل میگیرم" : this.props.user.address,
                                        checked: !this.state.checked,
                                    })}

                                    style={{
                                        flexDirection: "row",
                                       // alignSelf: "flex-end",
                                        marginHorizontal: moderateScale(18),
                                        marginTop: moderateScale(8)
                                    }}>
                                    <CheckBox
                                        color={ !this.state.checked ? Colors.colorDark : Colors.red}
                                        checked={this.state.checked} onPress={(check) => {


                                        this.setState({
                                            checked: !this.state.checked,
                                        })


                                    }}/>
                                    <View style={{width:moderateScale(15)}}/>
                                    <View
                                        >
                                        <HMTextView
                                            text="اطلاعاتم بصورت محرمانه باشد"
                                            style={{color: !this.state.checked ? Colors.colorDark : Colors.red}}
                                        />
                                    </View>

                                </TouchableOpacity>*/}

                                {/*  <BoldTextView textt="نام و نام خانوادگی"

                                          selfStyle={{
                                              marginEnd: moderateScale(10),
                                              color: colorPrimaryDark,
                                              fontSize: moderateScale(15),
                                              textAlign: "right"
                                          }}/>

                            <HMTextInput
                                value={this.state.First_name}
                                onChangeText={text => this._changeTextFirst_name(text)} autoFocus
                                textContentType="telephoneNumber" placeholder="نام خود را وارد نمایید" style={{
                                width: "90%",
                                fontFamily: "IRANSansMobile",
                                fontSize: moderateScale(14)
                            }} underlineColorAndroid="transparent"/>
                            <BoldTextView textt={i18n.t('constant.address')} selfStyle={{
                                color: colorPrimaryDark,
                                fontSize: moderateScale(15),
                                textAlign: "right",
                                marginTop: moderateScale(10)
                            }}/>

                            <HMTextInput
                                value={this.state.Password}
                                onChangeText={text => this._changeTextPassword(text)}
                                autoFocus
                                placeholder="آدرس خود را وارد نمایید (حداقل ۱۰ کاراکتر)"
                                style={{
                                    width: "90%",
                                    fontFamily: "IRANSansMobile",
                                    fontSize: moderateScale(14)
                                }}
                                _multiline
                                _height={80}
                                underlineColorAndroid="transparent"/>*/}
                                {/*<TextView textt={i18n.t('constant.MustContainOneCharacter')}*/}
                                {/*selfStyle={[InputStyles.error, this._checkDisplay(nameError)]}/>*/}
                                {/*<BoldTextView textt={i18n.t('constant.address')} selfStyle={{*/}
                                {/*marginEnd: moderateScale(10),*/}
                                {/*marginTop: moderateScale(10),*/}
                                {/*color: colorPrimaryDark,*/}
                                {/*fontSize: moderateScale(15),*/}
                                {/*textAlign: "right",*/}


                                {/*}}/>*/}
                                {/*<HMTextInput*/}
                                {/*value={this.state.Password}*/}
                                {/*onChangeText={text => this._changeTextPassword(text)}*/}
                                {/*placeholder="آدرس خود را وارد نمایید (حداقل ۱۰ کاراکتر)" _multiline _height={80} styles={{*/}
                                {/*marginStart: moderateScale(10),*/}
                                {/*width: "80%",*/}

                                {/*fontFamily: "IRANSansMobile",*/}
                                {/*fontSize: moderateScale(14)*/}
                                {/*}} underlineColorAndroid="transparent"/>*/}

                                {/*<TextView textt={i18n.t('constant.MustContainOneCharacter')}*/}
                                {/*selfStyle={[InputStyles.error, this._checkDisplay(PasswordError)]}/>*/}
                                {/* <BoldTextView textt="کد معرف" selfStyle={{
                                marginEnd: moderateScale(10),
                                color: colorPrimaryDark,
                                fontSize: moderateScale(15),
                                textAlign: "right",
                                marginTop: moderateScale(10)
                            }}/>

                            <HMTextInput
                                value={this.state.Address}
                                onChangeText={text => this._changeTextInviteCode(text)} autoFocus
                                textContentType="telephoneNumber" placeholder="کد معرف را وارد نمایید" style={{
                                width: "90%",
                                fontFamily: "IRANSansMobile",
                                fontSize: moderateScale(14)
                            }} underlineColorAndroid="transparent"/>*/}


                                {/*<AnimateLoadingButton*/}
                                {/*ref={c => (this.loadingButton = c)}*/}
                                {/*width={moderateScale(300)}*/}
                                {/*height={verticalScale(50)}*/}
                                {/*title=i18n.t('constant.Register')*/}
                                {/*titleFontFamily={Constants.regularFontName}*/}
                                {/*containerStyle={{marginTop: moderateScale(20)}}*/}
                                {/*titleFontSize={moderateScale(16)}*/}
                                {/*titleColor="rgb(255,255,255)"*/}
                                {/*backgroundColor={Colors.colorPrimary}*/}
                                {/*borderRadius={4}*/}

                                {/*onPress={() => this.checkInput()}*/}
                                {/*/>*/}
                                {/*  <TouchableOpacity style={{
                                    backgroundColor: Colors.colorPrimary,
                                    width: "85%",
                                    height: moderateScale(40),
                                    alignSelf: 'center',
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginTop: moderateScale(10),
                                    borderRadius: moderateScale(6)
                                    // borderRadius:moderateScale(2)
                                }}
                                                  onPress={() => this.checkInput()}
                                >
                                    <View
                                        style={{flexDirection: "row", alignItems: "center", justifyContent: "center"}}>
                                        <HMTextView type={"bold"} text={i18n.t('constant.Register')} style={{
                                            color: "white",
                                            fontSize: moderateScale(16),
                                        }}/>

                                    </View>
                                </TouchableOpacity>*/}

                                <View
                                    style={{
                                        width: '100%',
                                        height: moderateScale(42),
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginBottom: moderateScale(3)
                                    }}>

                                    {


                                        <View
                                            style={{
                                                width: '100%',
                                                height: moderateScale
                                                (42),
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginBottom: moderateScale(3)
                                            }}
                                        >
                                            <TouchableOpacity
                                                onPress={() => {
                                                    // this.refs['viewPager'].setPage(this.state.currentPage - 1);
                                                    //this.refs['viewPager'].setPage(this.state.currentPage - 1);

                                                    this.goBack();
                                                }}
                                                style={{
                                                    flex: .48,
                                                    height: moderateScale(42),
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backgroundColor: Colors.colorPrimary,
                                                    borderRadius: moderateScale(6)

                                                }}>

                                                <HMTextView
                                                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                    text={i18n.t('constant.Back')} type={"bold"}
                                                    style={{
                                                        fontSize: moderateScale(13),
                                                        marginVertical: moderateScale(6),
                                                        marginHorizontal: moderateScale(4),
                                                        color: Colors.white
                                                    }}/>
                                            </TouchableOpacity>

                                            <View style={{width: moderateScale(8)}}/>
                                            <TouchableOpacity

                                                onPress={() => {

                                                    let {currentPage} = this.state;

                                                    if (Platform.OS !== "web" && (currentPage === 1 || currentPage === 4)) {
                                                        Keyboard.dismiss();

                                                    }
                                                    setTimeout(() => {
                                                        this.checkGoNextStep()
                                                    }, Platform.OS !== "web" && (currentPage === 1 || currentPage === 4) ? 100 : 1)


                                                }}
                                                style={{
                                                    flex: .48,
                                                    height: moderateScale(42),
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backgroundColor: Colors.colorPrimary,
                                                    borderRadius: moderateScale(6)
                                                }}>
                                                <HMTextView
                                                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                    text={textButtonNext} type={"bold"}
                                                    style={{
                                                        fontSize: moderateScale(13),
                                                        marginVertical: moderateScale(6),
                                                        marginHorizontal: moderateScale(4),
                                                        color: Colors.white
                                                    }}/>
                                            </TouchableOpacity>
                                        </View>

                                    }

                                </View>
                            </View>

                        </View>
                    </KeyboardAvoidingView>
                </View>

                {
                    this.props.NoInternetDialog ?
                        <DialogConnectionCustomize
                            onPress={() => this.checkInput()}
                        />
                        :
                        null
                }
                {
                    this.props.isLoading || this.props.isLoadingSet || this.state.isLoading ?
                        <DialogLoadingCustomize/>
                        : null
                }

                <HMDatePicker
                    NameDate={"BirthDay"}
                    isVisible={this.state.isVisible}
                    cancel={
                        () => {
                            container.setState({
                                isVisible: false
                            })
                        }

                    }
                    setBirthDay={
                        (BirthDay) => {
                            container.setState({
                                BirthDay: BirthDay,
                                isVisible: false

                            })
                        }

                    }
                />
                <HMModal
                    isVisible={this.state.visibleModal}
                    //visible={this.state.visibleModal}
                    backdropColor={Colors.gray}
                    backdropOpacity={0.8}
                    animationIn="zoomInDown"
                    animationOut="zoomOutUp"
                    animationInTiming={600}
                    animationOutTiming={600}
                    backdropTransitionInTiming={600}
                    backdropTransitionOutTiming={600}
                    //style={{height: '60%'}}
                    onBackdropPress={() => this.hiddenModal()}
                    onBackButtonPress={() => this.hiddenModal()}

                    animationType="slide"
                    // transparent={true}
                >

                    <View style={[Platform.OS === 'web' ? {width: "90%",} : {},
                        {

                            padding: moderateScale(16),
                            backgroundColor: Colors.white,
                            border: moderateScale(4),

                        }]}>

                        <ScrollView
                            style={{
                                width: '100%'

                            }}
                            ref={scroll => this._scroll = scroll}
                            keyboardShouldPersistTaps="handled"
                        >
                            {
                                ServiceType ?
                                    <PaySatiaScreen
                                        item={ServiceType}
                                        checkScreenRegister={true}
                                        Phone={PhoneNumberForReview}
                                        funcSetServiceType={this.setServiceType}
                                    />
                                    :
                                    null
                            }

                        </ScrollView>
                    </View>
                </HMModal>

            </View>
        );
    }

    hiddenModal() {
        this.setState({
                visibleModal: false
            },
            () => {
            })
    }

    checkGoNextStep() {
        let message = null;
        let {currentPage, selectInternetType, selectStatusLine, selectStatusAgreement, ServiceType, PhoneNumberForReview} = this.state;
        //   this.refs['viewPager'].setPage(this.state.currentPage + 1);
        // if (this.state.currentPage == 0)
        //     Keyboard.dismiss()
        let checkInputRegisterValue = null;


        if (currentPage <= 5) {
            if (currentPage === 4) {
                if (!ServiceType) {
                    message = " سرویس انتخاب شده در دسترس نیست"
                } else
                    checkInputRegisterValue = this.checkInputRegister(["First_name", "Last_name", "Mobile", "NationalCode", "ShSh", "PostalCode", "address", "Education"])
            }

            if (currentPage == 0 && !selectInternetType)
                Toast.show({
                    // type: 'success | error | info',
                    type: 'error',
                    //  position: 'top | bottom',
                    position: 'top',
                    text1: i18n.t('constant.message'),
                    text2: i18n.t('constant.SelectItem'),
                    visibilityTime: 4000,
                    autoHide: true,
                    //  topOffset: 30,
                    // bottomOffset: 40,
                    onShow: () => {
                    },
                    onHide: () => {
                    }
                })
            /*   HMAlert(i18n.t('constant.message'), i18n.t('constant.SelectItem'), [
                       // {text: 'Ask me later', onPress: () => {}},
                       // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                       {
                           text: i18n.t('constant.ok'), onPress: () => {
                           }
                       },
                   ],
                   {cancelable: true}
               )*/
            // else if (currentPage == 1 && !selectStatusLine && !Tools.checkPhone(window['PhoneNumberForReview'])) {
            else if (currentPage == 1 && !selectStatusLine && !Tools.checkPhone(PhoneNumberForReview)) {
                /*   Toast.show({
                       type: 'my_custom_type',
                       props: { uuid: 'bba1a7d0-6ab2-4a0a-a76e-ebbe05ae6d70' }
                   });*/
               // console.log("state111", this.state)

                Toast.show({
                    // type: 'success | error | info',
                    type: 'custom_error',
                    //  position: 'top | bottom',
                    position: 'top',
                    text1: i18n.t('constant.message'),
                    text2: "لطفا جهت بررسی شماره تلفن خود را بصورت صحیح وارد نموده و سپس روی دکمه بررسی خط تلفن کلیک نمایید",
                    visibilityTime: 4000,
                    autoHide: true,
                    //  topOffset: 30,
                    // bottomOffset: 40,
                    onShow: () => {
                    },
                    onHide: () => {
                    }
                })
                /*     HMAlert(i18n.t('constant.message'), "لطفا جهت بررسی شماره تلفن خود را بصورت صحیح وارد نموده و سپس روی دکمه بررسی خط تلفن کلیک نمایید", [
                             // {text: 'Ask me later', onPress: () => {}},
                             // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                             {
                                 text: i18n.t('constant.ok'), onPress: () => {
                                 }
                             },
                         ],
                         {cancelable: true}
                     )*/
            }
            else if (currentPage == 2 && !ServiceType) {
                Toast.show({
                    // type: 'success | error | info',
                    type: 'custom_error',
                    //  position: 'top | bottom',
                    position: 'top',
                    text1: i18n.t('constant.message'),
                    text2: "لطفا بسته اینترنت خود را انتخاب نمایید",
                    visibilityTime: 4000,
                    autoHide: true,
                    //  topOffset: 30,
                    // bottomOffset: 40,
                    onShow: () => {
                    },
                    onHide: () => {
                    }
                })
                /*       HMAlert(i18n.t('constant.message'), "لطفا بسته اینترنت خود را انتخاب نمایید", [
                               // {text: 'Ask me later', onPress: () => {}},
                               // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                               {
                                   text: i18n.t('constant.ok'), onPress: () => {
                                   }
                               },
                           ],
                           {cancelable: true}
                       )*/
            } else if (currentPage == 3 && !selectStatusAgreement) {
                this.setState({
                        selectStatusAgreement: true
                    },
                    () => {
                        this.nextStep()
                    }
                )
                /*  Toast.show({
                      // type: 'success | error | info',
                      type: 'info',
                      //  position: 'top | bottom',
                      position: 'top',
                      text1: i18n.t('constant.message'),
                      text2: "لطفا قرداد را خوانده و تایید می نمایید",
                      visibilityTime: 4000,
                      autoHide: true,
                      //  topOffset: 30,
                      // bottomOffset: 40,
                      onShow: () => {
                      },
                      onHide: () => {
                      }
                  })*/
                /*   HMAlert(i18n.t('constant.message'), "لطفا قرداد را خوانده و تایید می نمایید", [
                           // {text: 'Ask me later', onPress: () => {}},
                           // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                           {
                               text: i18n.t('constant.ok'), onPress: () => {
                                   this.setState({
                                           selectStatusAgreement: true
                                       },
                                       () => {
                                           this.nextStep()
                                       }
                                   )


                               }
                           },
                       ],
                       {cancelable: true}
                   )*/
            }
            /*
NationalCode: '',
First_name: '',
Last_name: '',
Mobile: '',
Address: '',
PostalCode: '',
IdentifierCode: '',
Email: '',
Education: '',
BirthDay: '',
*/
            else if (currentPage == 4 && (!checkInputRegisterValue || !this.state.BirthDay)) {

                Toast.show({
                    // type: 'success | error | info',
                    type: 'custom_error',
                    //  position: 'top | bottom',
                    position: 'top',
                    text1: i18n.t('constant.message'),
                    text2: message ? message : (!checkInputRegisterValue ? (NameInputAlert + " را صحیح وارد نمایید") : "تاریخ تولد را انتخاب نمایید"),
                    visibilityTime: 4000,
                    autoHide: true,
                    //  topOffset: 30,
                    // bottomOffset: 40,
                    onShow: () => {
                    },
                    onHide: () => {
                    }
                })
                /*    HMAlert(i18n.t('constant.message'), NameInputAlert + " را صحیح وارد نمایید", [
                            // {text: 'Ask me later', onPress: () => {}},
                            // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                            /!*  {
                                  text: i18n.t('constant.ok'), onPress: () => {


                                  }
                              },*!/
                        ],
                        {cancelable: true}
                    )*/
            }
            else if (currentPage == 5) {


                Tools.GoLink(this.state.resultAllRegister.Url2, "self")
            }
            else {
                if (!selectStatusLine && currentPage == 1) {

                    this.ConnectServer("checkPhone");
                    /*   this.setState({
                           selectStatusLine: true
                       })*/
                    // alert("server")
                }

                else {
                    if (currentPage >= 4)
                        this.ConnectServer("register")
                    else
                        this.nextStep()
                }

            }
        } else {

            this.ConnectServer("register")
        }

    }

    ConnectServer(type) {
        let {PhoneNumberForReview, NationalCode, First_name, Last_name, Mobile, address, PostalCode, ShSh, IdentifierCode, Email, Education, BirthDay, typeSelectCheckBoxPersonalityType, typeSelectCheckBoxGender, ServiceType} = this.state;

        this.setState({
            //ShowImage:true
            isLoading: true,
            NoInternetDialog: false,

        })

        let url = "";
        const formData = new FormData();
        formData.append('lang', i18n.locale);
        formData.append('platform', Platform.OS);
        switch (type) {
            case "checkPhone":
                url = "https://app.satia.co/proxy.php/" + "register/checkPhone";
                formData.append('phone', Tools.persianToEnglish(PhoneNumberForReview));
                break;
            // case "regulation":
            //     url =typeExport._baseUrlSatia + "register/getRegulation";

            //     formData.append('phone', this.state.PhoneNumberForReview);
            //    break;
            case "register":
                let {Account} = store.getState().reducerSplashSatiaScreen;

                url = typeExport._baseUrlSatia + "register/store";

                /*
                 selectStatusLine: false,
            selectStatusAgreement: false,
            PhoneNumberForReview: null,
            NationalCode: '',
            First_name: '',
            Last_name: '',
            Mobile: '',
            address: '',
            PostalCode: '',
            IdentifierCode: '',
            Email: '',
            Education: '',
            BirthDay: '',
            checked: false,
            indexSelectGender: 1,
                 */
                formData.append('phone', Tools.persianToEnglish(PhoneNumberForReview));
                formData.append('CodeMeli', Tools.persianToEnglish(NationalCode));
                formData.append('Name', First_name);
                formData.append('family', Last_name);
                formData.append('Mobile', Tools.persianToEnglish(Mobile));
                formData.append('Address', address);
                formData.append('CodePosty', Tools.persianToEnglish(PostalCode));
                formData.append('ShSh', Tools.persianToEnglish(ShSh));
                formData.append('MoarefTel', Tools.persianToEnglish(IdentifierCode));

                formData.append('MoarefRef', Account ? Account.Serial : (MoarefRef ? MoarefRef : 0));

                formData.append('Email', Email);
                formData.append('Madrak', Education ? Education.value : null);
                formData.append('Birthday', BirthDay);
                formData.append('Personality', typeSelectCheckBoxPersonalityType);
                formData.append('Sex', typeSelectCheckBoxGender);
                formData.append('ServiceRef', ServiceRef ? ServiceRef : (ServiceType ? ServiceType.Serial : null));

                break;
        }
        //    formData.append('token', this.props.token);
        //  formData.append('customer', this.props.DataSplashSatiaScreen.Account ? JSON.stringify(this.props.DataSplashSatiaScreen.Account) : null);


        const config = {
            headers: {
                "Content-Type": "multipart/form-data; charset=utf-8;",
                // 'Content-Type': 'application/json',
                // "Authorization": `Basic ${params.token}`,
                timeout: typeExport._TIMEOUT_FILE
            }
        };

        axios({
            method: 'post',
            url: url,
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

        })
        //   axios.post(typeExport._baseUrlSatia + "ibs/littlemore", formData, config)
            .then(async response => {
                let data = response.data;
                let message = data.message;
                this.setState({
                    //ShowImage:true
                    //list: data.status ? list : this.state.list,
                    //TypeDocumentsList:[],
                    isLoading: false,
                    NoInternetDialog: !data.status,

                })
                switch (type) {
                    case "checkPhone":
                        this.setState({

                            selectStatusLine: data.status,
                            messageStatusLine: data.message,
                            resultCheckPhone: data.result,

                        });
                        break;
                    case "regulation":
                        //     formData.append('phone', this.state.PhoneNumberForReview);
                        break;
                    case "register":
                        let ch = "";
                        if (message && message instanceof Array) {
                            //message = message[0] + "";
                            for (let i = 0; i < message.length; i++) {
                                ch += message[i].label + "\n";
                            }
                            message = ch;

                        }
                        this.setState({

                            resultRegister: data.status ? data.result : null,
                            resultAllRegister: data.status ? data : null,
                            ServiceType: data.status && data.service ? data.service : this.state.ServiceType,

                        })

                        if (data.status) {

                            this.nextStep()
                            //  alert("dddddd")
                            // Tools.GoLink(response.data.Url2, "self")


                        }
                        break;
                }

                // if (data.status) {

                // }
                // else {
                //     this.setState({
                //         selectStatusLine: false
                //     })
                // }
                if (type === "register" && data.status) {

                }
                else
                    Toast.show({
                        // type: 'success | error | info',
                        type: data.status ? 'custom_success' : 'custom_error',
                        //  type: data.status ? 'custom_success' : 'custom_error',
                        //  position: 'top | bottom',
                        position: 'top',
                        text1: i18n.t('constant.message'),
                        text2: message,
                        visibilityTime: 4000,
                        autoHide: true,
                        //  topOffset: 30,
                        // bottomOffset: 40,
                        onShow: () => {
                        },
                        onHide: () => {
                        }
                    })
                // data.status ? this.state.listImage.push(image) : null;
                /*       HMAlert(
                           i18n.t('constant.message'),
                           data.message,
                           [
                               {
                                   text: i18n.t('constant.ok'), onPress: () => {

                                   }


                               },

                           ],
                           {cancelable: true}
                       )*/


            }).catch((e) => {
            Toast.show({
                // type: 'success | error | info',
                type: 'custom_error',
                //  position: 'top | bottom',
                position: 'top',
                text1: i18n.t('constant.message'),
                text2: "خطا در ارتباط با سرور لطفا مجددا تلاش نمایید",
                visibilityTime: 4000,
                autoHide: true,
                //  topOffset: 30,
                // bottomOffset: 40,
                onShow: () => {
                },
                onHide: () => {
                }
            })
            /*    HMAlert(
                    i18n.t('constant.message'),
                    "خطا در ارتباط با سرور لطفا مجددا تلاش نمایید",
                    [
                        {
                            text: i18n.t('constant.ok'), onPress: () => {

                            }


                        },

                    ],
                    {cancelable: true}
                )*/
            this.setState({
                //ShowImage:true
                isLoading: false,
                NoInternetDialog: true,


            })
            switch (type) {
                case "checkPhone":
                    this.setState({

                        selectStatusLine: false,
                        messageStatusLine: "خطا در ارتباط با سرور لطفا مجددا تلاش نمایید",

                    });
                    break;
                case "regulation":
                    //     formData.append('phone', this.state.PhoneNumberForReview);
                    break;
                case "register":

                    this.setState({

                        // resultRegister: data.result,

                    })

                    break;
            }

            console.log('error', e)
        })
    }

    getNameInput(data) {
        /*
           NationalCode: '',
            First_name: '',
            Last_name: '',
            Mobile: '',
            address: '',
            PostalCode: '',
            IdentifierCode: '',
            Email: '',
            Education: '',
            BirthDay: '',
             */
        //console.log("getNameInput", data)
        switch (data) {
            case "First_name" :
                return "نام";

            case "Last_name" :
                return "نام خانوادگی";

            case "NationalCode" :
                return "کد ملی";
            case "ShSh" :
                return "شماره شناسنامه";

            case "Mobile" :
                return "موبایل";

            case "address" :
                return "آدرس";

            case "PostalCode" :
                return "کد پستی";

            case "IdentifierCode" :
                return "کد معرف";

            case "Email" :
                return "ایمیل";

            case "Education" :
                return "تحصیلات";

        }
    }


    checkInputRegister(data) {
        if (data)
            for (let i = 0; i < data.length; i++) {
                let itemData = data[i];

                //   console.log("[data[i]]", data, data[i], window[data[i]])
                let result = Tools.CheckValue(this.state[itemData])
                //  let result = Tools.CheckValue(window[data[i]])
                // console.log("CheckValue", result);

                if (result && (itemData !== "address") && (itemData !== "Education"))
                    result = Tools.persianToEnglish(result)

                switch (data) {


                    case "NationalCode" :
                        if (!Tools.check_national_code(result))
                            result = null;
                        break;
                    case "Mobile" :
                        if (!Tools.check_Mobile(result))
                            result = null;
                        break;

                    case "PostalCode" :
                        result = (result && result.length >= 10)
                        break;

                    case "Education" :
                        result = (result && result.index != -1)
                        // return "کد پستی";
                        break;

                    default :
                    // return result;

                }
                if (result) {
                    // return data[i]
                }
                else {
                    NameInputAlert = this.getNameInput(itemData)
                    // console.log("qqqqq", data[i], i)
                    /*  HMAlert(i18n.t('constant.message'), this.getNameInput(data[i]) + " را صحیح وارد نمایید", [
                              // {text: 'Ask me later', onPress: () => {}},
                              // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                            /!*  {
                                  text: i18n.t('constant.ok'), onPress: () => {


                                  }
                              },*!/
                          ],
                          {cancelable: true}
                      )*/
                    return null
                }
            }
        return true
    }

    nextStep() {
        // if (this.state.currentPage == 1 && this.state.resultCheckPhone && !this.state.ServiceType && ServiceRef)
        //     this.connectToServer();

        this.setState({
                typeButton: "next",
                listSearch: [],
                textInputSearch: '',
                currentPage: this.state.currentPage + (this.state.currentPage == 0 && this.state.selectInternetType != "A" ? 2 : (this.state.currentPage == 1 && ServiceRef ? 2 : 1))
            }
            , () => {

            }
        )
    }

    goBack() {
        if (this.state.currentPage >= 1) {
            this.setState({
                    currentPage: this.state.currentPage - (this.state.currentPage == 2 && this.state.selectInternetType != "A" ? 2 : (this.state.currentPage == 3 && ServiceRef ? 2 : 1)),
                    typeButton: "back",
                    listSearch: [],
                    textInputSearch: '',
                }
                , () => {

                }
            )
        } else {
            NavigationService.Pop();
        }
    }

    goNext(item, index) {
        let selectItem = "selectItem_" + index
        let selectIndex = "selectIndex_" + index

        switch (this.state.currentPage) {
            case 1:

                this.setState(prevState => ({
                        [selectItem]: item,
                        [selectIndex]: index,
                        indexSelectedArray1: index,
                        itemSelectedArray1: item,

                        itemSelectedArray1Sub: null,
                        indexSelectedArray1Sub: -1,
                        // itemSelectedArray1Sub: item.subjects[0],
                        // indexSelectedArray1Sub: 0,
                        typeButton: "next",
                        currentPage: this.state.currentPage + 1
                        //pageDataArray1Sub:this.pageDataArray1[index]
                        // ListMoveToErrore: [...prevState.ListMoveToErrore, name]
                    }),
                    () => {


                        let r = "ref_Image"
                        setTimeout(function () {

                            try {
                                content.list.scrollToIndex({
                                    animated: true,
                                    index: Platform.OS === 'android' ? 0 : 0
                                })

                            } catch (e) {

                            }

                            // alert("df")
                        }, 400)
                        //  content.list.scrollToIndex(item)
                        // this[r].measureLayout(
                        //  this.list.measureLayout(
                        //      ReactNative.findNodeHandle(this._scroll),
                        //      (x, y) => {
                        //          this._scroll.scrollTo({
                        //              x: 0,
                        //              y: y - moderateScale(40),
                        //              animated: true
                        //          });
                        //      }
                        //  );

                        //   this.setState({currentPage: this.state.currentPage + 1})
                        //      this._scrollIntoView("ref_" + this.state.ListMoveToErrore[0])
//
                    }
                )
                break;

            case 2:
                this.setState(prevState => ({
                        [selectItem]: item,
                        [selectIndex]: index,
                        indexSelectedArray1Sub: index,
                        itemSelectedArray1Sub: item,
                        typeButton: "next"
                        //  pageDataArray1Sub:this.pageDataArray1[index]
                        // ListMoveToErrore: [...prevState.ListMoveToErrore, name]
                    }),
                    () => {

                        this.setState({currentPage: this.state.currentPage + 1})
                        //      this._scrollIntoView("ref_" + this.state.ListMoveToErrore[0])
//
                    }
                )
                break;
            case 3:
                /*       this.setState(prevState => ({
                               [selectItem]: item,
                               [selectIndex]: index,
                               indexSelectedArray2: index,
                               itemSelectedArray2: item,

                               //   itemSelectedArray2Sub: item.subplaces[0],
                               // indexSelectedArray2Sub: 0,

                               itemSelectedArray2Sub: null,
                               indexSelectedArray2Sub: -1,
                               typeButton: "next"
                               // ListMoveToErrore: [...prevState.ListMoveToErrore, name]
                           }),
                           () => {

                               this.setState({currentPage: this.state.currentPage + 1})
                               //      this._scrollIntoView("ref_" + this.state.ListMoveToErrore[0])
//
                           }
                       )*/
                break;

            case 4:
                /*   this.setState(prevState => ({
                           [selectItem]: item,
                           [selectIndex]: index,
                           indexSelectedArray2Sub: index,
                           itemSelectedArray2Sub: item,
                           typeButton: "next"
                           //pageDataArray1Sub: this.pageDataArray1[index]
                           // ListMoveToErrore: [...prevState.ListMoveToErrore, name]
                       }),
                       () => {

                           this.setState({currentPage: this.state.currentPage + 1})
                           //      this._scrollIntoView("ref_" + this.state.ListMoveToErrore[0])
//
                       }
                   )*/
                break;
        }
    }

    setServiceType(data) {
        container.setState({ServiceType: data, currentPage: container.state.currentPage + 1},
            () => {

            }
        )
    }

    updateInput(event, name) {

        container.setState({
            [name]: event.target.value
        })
    }

    updateInputEndEditing(name, text) {
        container.setState({
            [name]: (!!text.nativeEvent && !!text.nativeEvent.text) ? text.nativeEvent.text : null
        })
    }

    renderStep(width) {
        //  let date = container.state[`finalDate` + container.state.NameDate] ? moment(container.state[`finalDate` + container.state.NameDate], 'jYYYY/jM/jD').format('YYYY-MM-DD') : null
        let {
            NationalCode,
            ShSh,
            First_name,
            Last_name,
            Mobile,
            address,
            PostalCode,
            IdentifierCode,
            Email,
            Education,
            SelectEducationValue,
            listEducation,
            BirthDay,
            listTypeInternet,
            resultCheckPhone,
            PhoneNumberForReview,
            messageStatusLine,
            selectStatusLine, selectInternetType,
            ServiceType, resultRegulationContent,
            NoInternetDialog,
            currentPage,
            isLoadingService,
        } = this.state;

        let {Account, unitValue, unit} = store.getState().reducerSplashSatiaScreen;
        unitValue = unitValue ? unitValue : 10;
        unit = unit ? unit : "تومان";
        switch (currentPage) {

            case 0:
                return <View>

                    <View
                        style={{
                            //position:'absolute',
                            flexDirection: "row",
                            flexWrap: 'wrap',
                            flex: 1,

                            flexGrow: 1,
                            alignItems: 'center',
                            //justifyContent: 'center',
                            //  backgroundColor: _main ? "#eee" : Colors.transparent,
                            //  backgroundColor: "#876a79",
                        }}>

                        <View style={{
                            width: moderateScale(120),
                            paddingHorizontal: moderateScale(4)
                        }}>
                            <HMTextView
                                //type={"bold"}
                                text={"نوع اشتراک : "}
                                //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                style={{
                                    color: Colors.blackLight,
                                    fontSize: moderateScale(14),
                                    //   marginEnd: moderateScale(10),

                                }}/>
                        </View>

                        {
                            //    (_main ? (store.getState().reducerSplashSatiaScreen.results.menus ? store.getState().reducerSplashSatiaScreen.results.menus : []) : this.state.data).map((item, key) => {
                            listTypeInternet.map((item, key) => {

                                    return (
                                        //type=0 => پیوند ,type=1 => اخبار ,type=2 => صفحه ,type=3 => منو ,type=4 => اسلایدر ,type=5 => 137 یار ,type=6 => نقشه ,,type=7 => شکایات ,,type=8 =>  ارامستان ,
                                        <TouchableOpacity
                                            key={key}
                                            onPress={() => {
                                                this.setState({
                                                        selectInternetType: item.type,
                                                        resultCheckPhone: item.type == "w" ? null : resultCheckPhone
                                                    },
                                                    () => {
                                                        this.nextStep()
                                                        switch (parseFloat(item.type)) {

                                                            case 1 :

                                                                break;


                                                            case 2 :

                                                                break;


                                                            case 3 :

                                                                break;

                                                            default:
                                                            //alert("")

                                                        }
                                                    })


                                            }}
                                            style={{
                                                width: item.width ? (width / parseFloat(item.width == 0 ? 3.2 : item.width)) : width / moderateScale(1),
                                                height: item.height ? (width / parseFloat(item.height == 0 ? 3.2 : item.height)) : width / moderateScale(3.6),
                                                // padding: moderateScale(3),
                                                // backgroundColor: _main ? "#ffffff" : Colors.transparent,
                                                marginVertical: moderateScale(3),
                                                marginHorizontal: moderateScale(2),
                                                // marginBottom: moderateScale(1),
                                            }}
                                        >
                                            <HMImageView
                                                card={item.card}
                                                resizeMode={'contain'}
                                                _backgroundColorLoading={Colors.transparent}
                                                borderRadius={4}
                                                // uriComplete={BaseUrliImage + item.imageUrl}
                                                item={item}
                                                //  requireDataaaa={item.id == 64 || item.id == 68 || item.id == 46 || item.id == 54 ? this.func_switch(item.id) : false}

                                                // requireData
                                                // requireData={item.id == 64 || item.id == 68 || item.id == 46 || item.id == 54 ? this.state.path : false}
                                                // uriComplete={item.thumbnail}
                                                uriComplete={item.thumbnail}

                                                text={(item.title ? item.title : '')}
                                                source_image={item.image_require ? item.image_require : null}
                                                //  styleRoot={{backgroundColor: item.background_color ? Colors.transparent : "#d7011a"}}
                                                styleText={{
                                                    //marginTop: moderateScale(10),
                                                    textAlign: 'center',
                                                    color: item.font_color ? item.font_color : Colors.red,
                                                    fontSize: item.title ? moderateScale(11) : moderateScale(11)
                                                }}
                                                styleTextRoot={{flex: .4}}
                                                styleImageRoot={{flex: .6, padding: moderateScale(10)}}
                                                textChild={item.credit ? item.credit + ' ریال ' : null}
                                                styleTextChild={{
                                                    //marginTop: moderateScale(10),
                                                    textAlign: 'center',
                                                    color: Colors.blue,
                                                    fontSize: item.title ? moderateScale(9) : moderateScale(9)
                                                }}                                        // styleImage={{borderRadius: moderateScale(7)}}
                                            />
                                            {
                                                selectInternetType == item.type ?
                                                    <Image
                                                        source={selectInternetType == item.type ? PathFile.image.Check : null}
                                                        //resizeMode="stretch"
                                                        style={[{


                                                            position: 'absolute',
                                                            bottom: 0,
                                                            width: moderateScale(18),
                                                            height: moderateScale(18),
                                                            alignSelf: 'center',
                                                        }]}/>
                                                    :
                                                    null
                                            }

                                        </TouchableOpacity>
                                    ) //if you have a bunch of keys value pair

                                }
                            )
                        }
                    </View>

                </View>

            case 1:
                return <View>
                    {/*     <TextInput
                        style={ {
                            // marginLeft: inputPadding,
                            // marginHorizontal: moderateScale(4),
                            //  paddingLeft: inputPadding,
                            paddingHorizontal: moderateScale(4),
                            //  color: iconColor,
                            fontSize: moderateScale(12),
                            fontFamily: i18n.locale == 'en' ? null : typeExport.regularFontName,
                            textAlign: I18nManager.getConstants().isRTL && Platform.OS !== 'web' ? 'right' : 'left',

                        }}
                        value={PhoneNumberForReview}

                        onChangeText={text => {
                            if (messageStatusLine || selectStatusLine)
                                this.setState({
                                    messageStatusLine: null,
                                    selectStatusLine: false,
                                    // PhoneNumberForReview: text
                                })
                        }
                        }
                        onBlur={Platform.OS === "web" ? this.updateInput : null}
                    />*/}

                    <HMTextInputEfects
                        onRef={scroll => this["inputPhoneNumberForReview"] = scroll}

                        refName={"PhoneNumberForReview"}

                        type={"CostumeFumi"}
                        value={PhoneNumberForReview}

                        label={i18n.t('constant.PhoneNumberForReview') + " ( مثال 08632222222 ) "}
                        onChangeText={text => {
                            if (messageStatusLine || selectStatusLine)
                                this.setState({
                                    messageStatusLine: null,
                                    selectStatusLine: false,
                                    // PhoneNumberForReview: text
                                })
                        }
                            /*     this.setState({
                                 messageStatusLine: null,
                                 selectStatusLine: false,
                                 PhoneNumberForReview: text
                             })*/
                        }
                        onBlur={Platform.OS === "web" ? this.updateInput : null}
                        onEndEditing={(text) => Platform.OS === "web" ? null : this.updateInputEndEditing("PhoneNumberForReview", text)}
                        iconClass={"FontAwesomeIcon"}
                        iconName={'phone'}
                        keyboardType={'number-pad'}
                        // _scroll={this._scroll}

                        // secureTextEntry={true}
                        onSubmitEditing={() => {
                        }}

                        styleRoot={{width: "96%", alignSelf: "center"}}
                        containerStyle={{width: "100%"}}
                        containerInputStyle={{
                            borderWidth: moderateScale(1),

                            borderRadius: moderateScale(10),
                            // overflow: 'hidden',
                            marginVertical: moderateScale(4)
                        }}
                        border={true}

                    />
                    {
                        messageStatusLine ?
                            <View style={{width: "96%", alignSelf: "center"}}>
                                <HMTextView
                                    //  numberOfLines={1}
                                    // type={'bold'}
                                    //  text={i18n.t('constant.Gender') + " : "}
                                    text={messageStatusLine}
                                    // text={"در دو هفته اخیر با چند نفر در ارتباط بودید؟"}
                                    style={{
                                        marginTop: moderateScale(4),
                                        //  marginHorizontal: moderateScale(22),
                                        color: NoInternetDialog ? Colors.red : Colors.green,
                                        // marginEnd: moderateScale(10),
                                        fontSize: moderateScale(14),
                                        textAlign: 'center',
                                        //  marginHorizontal: moderateScale(8)

                                    }}/>
                            </View>
                            :
                            null
                    }
                </View>
            case 2:
                return <View style={{flex: 1}}>
                    {
                        <ListServiceSatiaScreen itemExtra={{
                            type: "register",
                            InternetType: resultCheckPhone && resultCheckPhone.Type ? resultCheckPhone.Type : (selectInternetType),
                            SerialMdfGroup: resultCheckPhone && resultCheckPhone.MdfGroup ? resultCheckPhone.MdfGroup : null,
                            Township: resultCheckPhone && resultCheckPhone.TownshipRef ? resultCheckPhone.TownshipRef : "1",
                            CustomerGroup: "1",
                            funcSetServiceType: this.setServiceType,
                            resultCheckPhone: resultCheckPhone,
                            Phone: PhoneNumberForReview,
                            MoarefRef: MoarefRef,
                        }}/>
                    }


                    {/*     <View
                        style={{
                            width: '100%',
                            flexDirection: 'row',
                            alignItems: 'center',
                            padding: moderateScale(2),
                            marginVertical: moderateScale(10)

                        }}>

                        <View
                            style={{
                            width: moderateScale(120),
                            paddingHorizontal: moderateScale(4)
                        }}>
                            <HMTextView
                                //type={"bold"}
                                text={"وسیله مورد نیاز : "}
                                //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                style={{
                                    color: Colors.blackLight,
                                    fontSize: moderateScale(14),
                                    //   marginEnd: moderateScale(10),

                                }}/>
                        </View>
                        <View style={{flex: .8,}}>
                            <HMSelectInput
                                onValueChange={(value) => {


                                    let idx = container.state.listModem.findIndex(obj => obj.value == container.state.typeBuilding);
                                    let res = null;
                                    if (idx !== -1) {
                                        res = container.state.listModem[idx]
                                    }

                                    this.setState({
                                        SelectModemValue: value,
                                        Modem: res ? {
                                            label: res.label,
                                            value: res.value,
                                            index: idx
                                        } : {label: i18n.t('constant.SelectItem'), value: idx, index: idx}
                                    })
                                }}
                                // error={this.state.errorSelectInput}
                                //
                                // //  requestServerRetry={container.getServerTypeDocuments}
                                // requestServer={() => {
                                // }}
                                value={this.state.SelectModemValue ? "" : i18n.t('constant.SelectItem')}
                                index={this.state.Modem ? this.state.Modem.index : -1}
                                itemSelectInput={this.state.Modem}
                                options={this.state.listModem}

                                styleRoot={{
                                    width: '100%'
                                }}
                            />
                        </View>


                    </View>*/}
                    {/*       <TouchableOpacity
                        style={{
                            width: '100%',
                            flexDirection: 'row',
                            alignItems: 'center',
                            padding: moderateScale(2),
                            marginVertical: moderateScale(10)
                        }}
                        onPress={() => {
                            NavigationService.navigateParams(MoarefRef ? "ListServiceSatiaScreen_Root" : "ListServiceSatiaScreen", {
                                type: "register",
                                InternetType: resultCheckPhone && resultCheckPhone.Type ? resultCheckPhone.Type : (selectInternetType),
                                SerialMdfGroup: resultCheckPhone && resultCheckPhone.MdfGroup ? resultCheckPhone.MdfGroup : null,
                                Township: resultCheckPhone && resultCheckPhone.TownshipRef ? resultCheckPhone.TownshipRef : "1",
                                CustomerGroup: "1",
                                funcSetServiceType: this.setServiceType,
                                resultCheckPhone: resultCheckPhone,
                                Phone: PhoneNumberForReview,
                                MoarefRef: MoarefRef,
                            })
                        }}
                    >

                        <View style={{
                            width: moderateScale(120),
                            paddingHorizontal: moderateScale(4)
                        }}>
                            <HMTextView
                                //type={"bold"}
                                text={"بسته اینترنت : "}
                                //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                style={{
                                    color: Colors.blackLight,
                                    fontSize: moderateScale(14),
                                    //   marginEnd: moderateScale(10),

                                }}/>
                        </View>
                        <View style={{flex: .8,}}>
                            <View
                                style={{
                                    flex: 1,
                                    flexDirection: 'row',
                                    justifyContent: "space-between",
                                    borderWidth: moderateScale(1),

                                    borderRadius: moderateScale(4),
                                    overflow: 'hidden',
                                    marginVertical: Platform.OS === 'ios' ? moderateScale(2) : 0,
                                    borderColor: Colors.blackLight,
                                    padding: moderateScale(Platform.OS === 'ios' ? 10 : 2),


                                }}>
                                <View style={{flex: .95}}>
                                    <HMTextView
                                        //type={"bold"}
                                        text={ServiceType ? (ServiceType.Name ? ServiceType.Name : ServiceType.Label) : "یک مورد را انتخاب نمایید"}
                                        //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                        style={{
                                            color: Colors.blackLight,
                                            fontSize: moderateScale(14),
                                            //   marginEnd: moderateScale(10),

                                        }}/>
                                </View>
                                <View style={{flex: .05, alignItems: 'center', justifyContent: 'center'}}>
                                    <HMTextView
                                        type={"bold"}
                                        text={"<"}
                                        //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                        style={{
                                            color: Colors.blackLight,
                                            fontSize: moderateScale(14),
                                            //   marginEnd: moderateScale(10),

                                        }}/>
                                </View>
                            </View>
                        </View>


                    </TouchableOpacity>*/}
                </View>
            case 3:
                return <View>

                    <HMTextView
                        //  numberOfLines={1}
                        // type={'bold'}
                        text={resultRegulationContent ? resultRegulationContent : RegulationContent}
                        style={{

                            color: Colors.blackLight,
                            // marginEnd: moderateScale(10),
                            fontSize: moderateScale(14),
                            //   textAlign:'center',
                            marginHorizontal: moderateScale(8)

                        }}/>

                </View>
            case 4:
                return <ScrollView
                    keyboardShouldPersistTaps="handled"
                    style={{flex: 1}}>

                    {/*    <View style={{width: "96%", alignSelf: 'center'}}>

                        <View style={{flex: .5, flexDirection: 'row', alignItems: 'center'}}>
                            <HMTextView
                                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                text={"نوع بسته : "}
                                type={"bold"}
                                style={{
                                    fontSize: moderateScale(14),
                                    marginVertical: moderateScale(6),
                                    marginHorizontal: moderateScale(4),
                                    color: Colors.blackLight,
                                }}/>

                            <HMTextView
                                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                text={ServiceType ? ServiceType.Name : "-"}
                                //type={"bold"}
                                style={{
                                    fontSize: moderateScale(13),
                                    marginVertical: moderateScale(6),
                                    marginHorizontal: moderateScale(4),
                                    color: Colors.colorDarkText
                                }}
                                styleRoot={{
                                    //  flexDirection: "row",
                                    flex: 1,
                                    //  width:'100%',
                                    //   justifyContent: "flex-end",
                                    flexWrap: 'wrap',

                                }}
                            />
                            <View style={{width: moderateScale(6)}}/>
                        </View>
                        <View style={{flex: .5, flexDirection: 'row',}}>
                            <HMTextView
                                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                text={"مبلغ کل : "}
                                type={"bold"}
                                style={{
                                    fontSize: moderateScale(14),
                                    marginVertical: moderateScale(6),
                                    marginHorizontal: moderateScale(4),
                                    color: Colors.blackLight
                                }}/>

                            <HMTextView
                                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                text={ServiceType ? parseInt(ServiceType.SumPrice / unitValue) + " " + unit : "-"}
                                type={"bold"}
                                style={{
                                    fontSize: moderateScale(13),
                                    marginVertical: moderateScale(6),
                                    marginHorizontal: moderateScale(4),
                                    color: Colors.green
                                }}
                                cammas
                            />

                            <View style={{width: moderateScale(8)}}/>
                            {
                                isLoadingService ?
                                    <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>
                                    :
                                    <TouchableOpacity
                                        onPress={() => {
                                            ServiceType ?
                                                this.setState({
                                                    visibleModal: true
                                                })
                                                :
                                                this.connectToServer()
                                        }}
                                    >

                                        <HMTextView
                                            //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                            text={ServiceType ? "نمایش فاکتور" : "تلاش مجدد"}
                                            type={"bold"}
                                            style={{
                                                fontSize: moderateScale(12),
                                                marginVertical: moderateScale(6),
                                                marginHorizontal: moderateScale(4),
                                                color: Colors.blue
                                            }}

                                        />

                                    </TouchableOpacity>

                            }
                        </View>

                    </View>*/}


                    <View style={{flexDirection: 'row', width: "96%", alignSelf: 'center'}}>

                        <View style={{flex: .5, flexDirection: 'row',}}>
                            <HMTextView
                                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                text={"شماره تلفن : "}
                                type={"bold"}
                                style={{
                                    fontSize: moderateScale(14),
                                    marginVertical: moderateScale(6),
                                    marginHorizontal: moderateScale(4),
                                    color: Colors.blackLight
                                }}/>

                            <HMTextView
                                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                text={PhoneNumberForReview}
                                //type={"bold"}
                                style={{
                                    fontSize: moderateScale(13),
                                    marginVertical: moderateScale(6),
                                    marginHorizontal: moderateScale(4),
                                    color: Colors.blackLight
                                }}/>
                        </View>
                        <View style={{flex: .5, flexDirection: 'row',}}>
                            <HMTextView
                                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                text={"شهرستان : "}
                                type={"bold"}
                                style={{
                                    fontSize: moderateScale(14),
                                    marginVertical: moderateScale(6),
                                    marginHorizontal: moderateScale(4),
                                    color: Colors.blackLight
                                }}/>

                            <HMTextView
                                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                text={resultCheckPhone && resultCheckPhone.city ? resultCheckPhone.city.Name : "_"}
                                //type={"bold"}
                                style={{
                                    fontSize: moderateScale(13),
                                    marginVertical: moderateScale(6),
                                    marginHorizontal: moderateScale(4),
                                    color: Colors.blackLight
                                }}/>
                        </View>

                    </View>
                    <View style={{flexDirection: 'row', width: "96%", alignSelf: 'center'}}>

                        <View style={{flex: .5, flexDirection: 'row',}}>
                            <HMTextView
                                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                text={"مرکز مخابراتی : "}
                                type={"bold"}
                                style={{
                                    fontSize: moderateScale(14),
                                    marginVertical: moderateScale(6),
                                    marginHorizontal: moderateScale(4),
                                    color: Colors.blackLight
                                }}/>

                            <HMTextView
                                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                text={resultCheckPhone ? resultCheckPhone.Name : "_"}
                                //type={"bold"}
                                style={{
                                    fontSize: moderateScale(13),
                                    marginVertical: moderateScale(6),
                                    marginHorizontal: moderateScale(4),
                                    color: Colors.blackLight
                                }}/>
                        </View>


                    </View>
                    <View style={{flexDirection: 'row', width: '94%', alignSelf: 'center'}}>

                        <View
                            style={{
                                flexDirection: 'row', flex: .53,
                                //width: "96%",
                                //  alignSelf: 'center',
                                alignItems: 'center',
                                marginVertical: moderateScale(3)
                            }}>
                            <HMTextView
                                //  numberOfLines={1}
                                type={'bold'}
                                text={"شخصیت" + " : "}
                                // text={"در دو هفته اخیر با چند نفر در ارتباط بودید؟"}
                                style={{
                                    //marginTop: moderateScale(18),
                                    marginHorizontal: moderateScale(4),
                                    color: Colors.blackLight,
                                    // marginEnd: moderateScale(10),
                                    fontSize: moderateScale(14),
                                    textAlign: 'center',
                                    //  marginHorizontal: moderateScale(8)

                                }}/>


                            <HMListCheckBox
                                data={{
                                    list: [
                                        {
                                            id: 1,
                                            //  name: i18n.t('constant.Injury')
                                            name: "مشترک حقیقی",
                                            type: "HA"
                                        },
                                        {
                                            id: 2,
                                            name: "مشترک حقوقی",
                                            type: "HO"
                                        },

                                    ],

                                    indexSelect: this.state['indexSelectCheckBoxPersonalityType'],
                                    name: 'PersonalityType',

                                }}

                                onPress={this.onPressSelectCheckBox
                                }

                            />
                        </View>
                        <View
                            style={{
                                flexDirection: 'row', flex: .47,
                                //width: "96%",
                                //alignSelf: 'center',
                                alignItems: 'center',
                                marginVertical: moderateScale(3)
                            }}>
                            <HMTextView
                                //  numberOfLines={1}
                                type={'bold'}
                                //  text={i18n.t('constant.Gender') + " : "}
                                text={i18n.t('constant.Gender') + " : "}
                                // text={"در دو هفته اخیر با چند نفر در ارتباط بودید؟"}
                                style={{
                                    //marginTop: moderateScale(18),
                                    marginHorizontal: moderateScale(4),
                                    color: Colors.blackLight,
                                    // marginEnd: moderateScale(10),
                                    fontSize: moderateScale(14),
                                    textAlign: 'center',
                                    //  marginHorizontal: moderateScale(8)

                                }}/>


                            <HMListCheckBox
                                data={{
                                    list: [
                                        {id: 1, name: i18n.t('constant.Man'), type: "MR"},
                                        {id: 2, name: i18n.t('constant.Woman'), type: "MS"},

                                    ],

                                    indexSelect: this.state['indexSelectCheckBoxGender'],
                                    name: 'Gender',

                                }}
                                onPress={this.onPressSelectCheckBox
                                }

                            />
                        </View>
                    </View>


                    <View style={{flexDirection: 'row', width: "96%", alignSelf: 'center'}}>

                        <View style={{flex: .5}}>
                            <HMTextInputEfects
                                onRef={scroll => this["inputFirst_name"] = scroll}

                                refName={"First_name"}

                                type={"CostumeFumi"}
                                value={First_name}

                                label={i18n.t('constant.First_name')}
                                /*       onChangeText={text => this.setState({
                                           First_name: text
                                       })}   */

                                // onChangeText={text => this.setInputText("First_name", text)}
                                onBlur={Platform.OS === "web" ? this.updateInput : null}
                                onEndEditing={(text) => Platform.OS === "web" ? null : this.updateInputEndEditing("First_name", text)}
                                iconClass={"FontAwesomeIcon"}
                                iconName={'phone'}
                                //keyboardType={'number-pad'}
                                // _scroll={this._scroll}

                                // secureTextEntry={true}
                                onSubmitEditing={() => this._focusNextField("inputLast_name")}
                                containerStyle={{}}
                                containerInputStyle={{
                                    borderWidth: moderateScale(1),

                                    borderRadius: moderateScale(10),
                                    // overflow: 'hidden',
                                    marginVertical: moderateScale(4)
                                }}
                                border={true}

                            />
                        </View>
                        <View style={{flex: .5}}>
                            <HMTextInputEfects
                                onRef={scroll => this["inputLast_name"] = scroll}

                                refName={"Last_name"}

                                type={"CostumeFumi"}
                                value={Last_name}

                                label={i18n.t('constant.Last_name')}
                                // onChangeText={text => this.setState({
                                //     Last_name: text
                                // })}
                                //    onChangeText={text => this.setInputText("Last_name", text)}
                                onBlur={Platform.OS === "web" ? this.updateInput : null}
                                onEndEditing={(text) => Platform.OS === "web" ? null : this.updateInputEndEditing("Last_name", text)}
                                iconClass={"FontAwesomeIcon"}
                                iconName={'phone'}
                                //keyboardType={'number-pad'}
                                // _scroll={this._scroll}

                                // secureTextEntry={true}
                                onSubmitEditing={() => this._focusNextField("inputMobile")}
                                containerStyle={{}}
                                containerInputStyle={{
                                    borderWidth: moderateScale(1),

                                    borderRadius: moderateScale(10),
                                    // overflow: 'hidden',
                                    marginVertical: moderateScale(4)
                                }}
                                border={true}

                            />
                        </View>

                    </View>
                    <View style={{flexDirection: 'row', width: "96%", alignSelf: 'center'}}>
                        <View style={{flex: .5}}>
                            <HMTextInputEfects

                                //  onRef={scroll => container["inputTheoryDepartmentEducationAndPreventionPhysicalConditionPlace"] = scroll}

                                // refName={"TheoryDepartmentEducationAndPreventionPhysicalConditionPlace"}

                                onRef={scroll => this["inputMobile"] = scroll}

                                refName={"Mobile"}

                                type={"CostumeFumi"}
                                value={Mobile}

                                label={i18n.t('constant.Mobile')}
                                /*     onChangeText={text => this.setState({
                                         Mobile: text
                                     })}*/
                                // onChangeText={text => this.setInputText("Mobile", text)}
                                onBlur={Platform.OS === "web" ? this.updateInput : null}
                                onEndEditing={(text) => Platform.OS === "web" ? null : this.updateInputEndEditing("Mobile", text)}
                                iconClass={"FontAwesomeIcon"}
                                iconName={'phone'}
                                // keyboardType={'number-pad'}
                                // _scroll={this._scroll}

                                // secureTextEntry={true}
                                onSubmitEditing={() => this._focusNextField("inputIdentifierCode")}

                                containerStyle={{}}
                                containerInputStyle={{
                                    backgroundColor: Colors.transparent,
                                    borderWidth: moderateScale(1),

                                    borderRadius: moderateScale(10),
                                    // overflow: 'hidden',
                                    marginVertical: moderateScale(4)
                                }}
                                border={true}
                                keyboardType={'number-pad'}

                            />
                        </View>
                        <View style={{flex: .5}}>
                            <HMTextInputEfects
                                onRef={scroll => this["inputIdentifierCode"] = scroll}

                                refName={"IdentifierCode"}

                                type={"CostumeFumi"}
                                value={MoarefRef ? MoarefRef : IdentifierCode}

                                label={i18n.t('constant.IdentifierCode')}
                                /*   onChangeText={text => this.setState({
                                       IdentifierCode: text
                                   })}*/
                                // onChangeText={text => this.setInputText("IdentifierCode", text)}
                                onBlur={Platform.OS === "web" ? this.updateInput : null}
                                onEndEditing={(text) => Platform.OS === "web" ? null : this.updateInputEndEditing("IdentifierCode", text)}
                                iconClass={"FontAwesomeIcon"}
                                iconName={'phone'}
                                // keyboardType={'number-pad'}
                                // _scroll={this._scroll}

                                // secureTextEntry={true}
                                onSubmitEditing={() => this._focusNextField("inputNationalCode")}

                                containerStyle={{}}
                                containerInputStyle={{
                                    backgroundColor: Colors.transparent,
                                    borderWidth: moderateScale(1),

                                    borderRadius: moderateScale(10),
                                    // overflow: 'hidden',
                                    marginVertical: moderateScale(4)
                                }}
                                border={true}
                                // editable={!(Account && MoarefRef)}
                                editable={Account ? false : !MoarefRef}
                            />
                        </View>


                    </View>
                    <View
                        style={{
                            flexDirection: 'row', width: "96%", alignSelf: 'center',
                        }}>

                        <View style={{flex: .5}}>
                            <HMTextInputEfects
                                onRef={scroll => this["inputNationalCode"] = scroll}

                                refName={"NationalCode"}

                                type={"CostumeFumi"}
                                value={NationalCode}

                                label={i18n.t('constant.NationalCode')}
                                /* onChangeText={text => this.setState({
                                     NationalCode: text
                                 })}*/
                                //onChangeText={text => this.setInputText("NationalCode", text)}
                                onBlur={Platform.OS === "web" ? this.updateInput : null}
                                onEndEditing={(text) => Platform.OS === "web" ? null : this.updateInputEndEditing("NationalCode", text)}
                                iconClass={"FontAwesomeIcon"}
                                iconName={'phone'}
                                keyboardType={'number-pad'}
                                // _scroll={this._scroll}

                                // secureTextEntry={true}
                                onSubmitEditing={() => this._focusNextField("inputShSh")}
                                containerStyle={{}}
                                containerInputStyle={{
                                    borderWidth: moderateScale(1),

                                    borderRadius: moderateScale(10),
                                    // overflow: 'hidden',
                                    marginVertical: moderateScale(4)
                                }}
                                border={true}

                            />


                        </View>
                        <View style={{flex: .5}}>
                            <HMTextInputEfects
                                onRef={scroll => this["inputShSh"] = scroll}

                                refName={"ShSh"}

                                type={"CostumeFumi"}
                                value={ShSh}

                                // label={i18n.t('constant.ShSh')}
                                label={"شماره شناسنامه"}
                                /* onChangeText={text => this.setState({
                                     ShSh: text
                                 })}*/
                                //onChangeText={text => this.setInputText("NationalCode", text)}
                                onBlur={Platform.OS === "web" ? this.updateInput : null}
                                onEndEditing={(text) => Platform.OS === "web" ? null : this.updateInputEndEditing("ShSh", text)}
                                iconClass={"FontAwesomeIcon"}
                                iconName={'phone'}
                                keyboardType={'number-pad'}
                                // _scroll={this._scroll}

                                // secureTextEntry={true}
                                onSubmitEditing={() => this._focusNextField("inputEmail")}
                                containerStyle={{}}
                                containerInputStyle={{
                                    borderWidth: moderateScale(1),

                                    borderRadius: moderateScale(10),
                                    // overflow: 'hidden',
                                    marginVertical: moderateScale(4)
                                }}
                                border={true}

                            />


                        </View>


                    </View>
                    <View style={{flexDirection: 'row', width: "96%", alignSelf: 'center'}}>

                        <View style={{flex: .5}}>
                            <HMTextInputEfects
                                onRef={scroll => this["inputEmail"] = scroll}

                                refName={"Email"}

                                type={"CostumeFumi"}
                                value={Email}

                                label={i18n.t('constant.Email')}
                                /*   onChangeText={text => this.setState({
                                       Email: text
                                   })}*/
                                // onChangeText={text => this.setInputText("Email", text)}
                                onBlur={Platform.OS === "web" ? this.updateInput : null}
                                onEndEditing={(text) => Platform.OS === "web" ? null : this.updateInputEndEditing("Email", text)}
                                iconClass={"FontAwesomeIcon"}
                                iconName={'phone'}
                                // keyboardType={'number-pad'}
                                // _scroll={this._scroll}

                                // secureTextEntry={true}
                                onSubmitEditing={() => this._focusNextField("inputPostalCode")}

                                containerStyle={{}}
                                containerInputStyle={{
                                    borderWidth: moderateScale(1),

                                    borderRadius: moderateScale(10),
                                    // overflow: 'hidden',
                                    marginVertical: moderateScale(4)
                                }}
                                border={true}

                            />
                        </View>
                        <View style={{flex: .5}}>
                            <HMTextInputEfects
                                onRef={scroll => this["inputPostalCode"] = scroll}

                                refName={"PostalCode"}

                                type={"CostumeFumi"}
                                value={PostalCode}

                                label={i18n.t('constant.PostalCode')}
                                /*   onChangeText={text => this.setState({
                                       PostalCode: text
                                   })}*/
                                ///onChangeText={text => this.setInputText("PostalCode", text)}
                                onBlur={Platform.OS === "web" ? this.updateInput : null}
                                onEndEditing={(text) => Platform.OS === "web" ? null : this.updateInputEndEditing("PostalCode", text)}
                                iconClass={"FontAwesomeIcon"}
                                iconName={'phone'}
                                // keyboardType={'number-pad'}
                                // _scroll={this._scroll}

                                // secureTextEntry={true}
                                onSubmitEditing={() => this._focusNextField("inputaddress")}

                                containerStyle={{}}
                                containerInputStyle={{
                                    borderWidth: moderateScale(1),

                                    borderRadius: moderateScale(10),
                                    // overflow: 'hidden',
                                    marginVertical: moderateScale(4)
                                }}
                                border={true}

                            />
                        </View>


                    </View>


                    <View style={{flexDirection: 'row', width: '100%'}}>
                        <View style={{width: "2%"}}/>
                        <View style={{flex: 1}}>
                            <HMTextInputEfects
                                onRef={scroll => this["inputaddress"] = scroll}

                                refName={"address"}

                                type={"CostumeFumi"}
                                value={address}

                                label={i18n.t('constant.address')}
                                /*   onChangeText={text => this.setState({
                                       address: text
                                   })}*/
                                //   onChangeText={text => this.setInputText("address", text)}
                                onBlur={Platform.OS === "web" ? this.updateInput : null}
                                onEndEditing={(text) => Platform.OS === "web" ? null : this.updateInputEndEditing("address", text)}
                                iconClass={"FontAwesomeIcon"}
                                iconName={'phone'}
                                // keyboardType={'number-pad'}
                                // _scroll={this._scroll}

                                // secureTextEntry={true}
                                onSubmitEditing={() => {
                                }}

                                //styleRoot={{marginStart:moderateScale(100)}}
                                containerInputStyle={{
                                    borderWidth: moderateScale(1),

                                    borderRadius: moderateScale(10),
                                    // overflow: 'hidden',
                                    marginVertical: moderateScale(4)
                                }}
                                border={true}

                            />
                        </View>
                    </View>
                    <View style={{flexDirection: 'row', width: "96%", alignSelf: 'center'}}>

                        <View style={{flex: .5, justifyContent: "center"}}>

                            <View style={{width: "93%", marginTop: moderateScale(16)}}>
                                <View
                                    style={{
                                        width: "100%",
                                        height: moderateScale(42),
                                        flexDirection: 'row',
                                        justifyContent: "space-between",
                                        borderWidth: moderateScale(1),

                                        borderRadius: moderateScale(4),
                                        overflow: 'hidden',
                                        //    marginVertical: Platform.OS === 'ios' ? moderateScale(2) : 0,
                                        borderColor: Colors.gray,
                                        padding: moderateScale(Platform.OS === 'ios' ? 10 : 2),


                                    }}>
                                    <View style={{flex: .95, justifyContent: 'center',}}>
                                        <HMTextView
                                            //type={"bold"}
                                            text={Education && Education.index != -1 ? SelectEducationValue : "مدرک تحصیلی ..."}
                                            //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                            style={{
                                                color: Education && Education.index != -1 ? Colors.blackLight : "#a3a3a3",
                                                fontSize: moderateScale(12),
                                                //   marginEnd: moderateScale(10),

                                            }}/>
                                    </View>
                                    <View style={{flex: .05, alignItems: 'center', justifyContent: 'center'}}>
                                        <HMTextView
                                            type={"bold"}
                                            text={"<"}
                                            //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                            style={{
                                                color: Colors.blackLight,
                                                fontSize: moderateScale(14),
                                                //   marginEnd: moderateScale(10),

                                            }}/>
                                    </View>
                                </View>
                                <View
                                    style={{
                                        position: "absolute", top: 0, right: 0, left: 0, bottom: 0,
                                        justifyContent: "center",
                                        opacity: .001
                                    }}>
                                    <HMSelectInput
                                        onValueChange={(value) => {


                                            let idx = container.state.listEducation.findIndex(obj => obj.value == value);
                                            let res = null;
                                            if (idx !== -1) {
                                                res = container.state.listEducation[idx]
                                            }

                                            this.setState({
                                                    SelectEducationValue: value,
                                                    Education: res ? {
                                                        label: res.label,
                                                        value: res.value,
                                                        index: idx
                                                    } : {label: "مدرک تحصیلی ...", value: idx, index: idx}
                                                },

                                                () => {
                                                    //  console.log("aaaaaa", this.state.Education)
                                                }
                                            )
                                        }}
                                        // error={this.state.errorSelectInput}
                                        //
                                        // //  requestServerRetry={container.getServerTypeDocuments}
                                        // requestServer={() => {
                                        // }}
                                        value={SelectEducationValue ? "" : "مدرک تحصیلی ..."}
                                        defaultValue={"مدرک تحصیلی ..."}
                                        index={Education ? Education.index : -1}
                                        itemSelectInput={Education}
                                        options={listEducation}

                                        styleRoot={{
                                            width: '100%',
                                            //    height: '100%'
                                        }}
                                    />
                                </View>
                            </View>


                        </View>
                        <View style={{flex: .5}}>
                            <View
                                style={{
                                    flexDirection: 'row', width: "96%", alignSelf: 'center',
                                    //marginVertical: moderateScale(8)

                                }}

                            >
                                <TouchableOpacity
                                    style={{
                                        flexDirection: 'row', width: "96%", alignSelf: 'center',
                                        overflow: 'hidden',
                                        borderRadius: moderateScale(4),
                                        borderWidth: moderateScale(1),
                                        borderColor: Colors.gray,
                                        justifyContent: 'space-between',
                                        paddingHorizontal: moderateScale(10),
                                        paddingVertical: moderateScale(2),
                                        marginTop: moderateScale(12),
                                        alignItems: 'center',

                                    }}
                                    onPress={() => {
                                        this.setState({isVisible: true})

                                    }}>
                                    <HMTextView
                                        noFont
                                        // type={"bold"}
                                        text={(BirthDay ? BirthDay : "تاریخ تولد انتخاب نشده ")}
                                        style={{
                                            color: Colors.blackLight,
                                            fontSize: moderateScale(13),

                                            //  marginEnd: moderateScale(10)
                                        }}/>

                                    <View style={{
                                        flexDirection: 'row',
                                        alignItems: 'center'
                                    }}>
                                        {/*  <HMTextView
                                    noFont
                                    type={"bold"}
                                    text={("تا تاریخ")}
                                    style={{
                                        color: Colors.blackLight,
                                        fontSize: moderateScale(12),

                                        //  marginEnd: moderateScale(10)
                                    }}/>*/}
                                        <HMIcon name="ios-calendar" style={{
                                            color: colorPrimary,
                                            fontSize: moderateScale(24),
                                            padding: moderateScale(4),
                                            //    alignSelf: "center",
                                        }}/>
                                    </View>


                                </TouchableOpacity>
                            </View>
                        </View>


                    </View>
                </ScrollView>
            case 5:

                return <View style={{flex: 1}}>
                    {
                        ServiceType ?
                            <PaySatiaScreen
                                item={ServiceType}
                                checkScreenRegister={true}
                                Phone={PhoneNumberForReview}
                                // funcSetServiceType={this.setServiceType}
                            />
                            :
                            null
                    }
                </View>
            case 6:
                return <View/>

        }

    }

    _focusNextField(nextField) {
        container[nextField].focus()
        /*      container[nextField].input.current.measureLayout(
                  ReactNative.findNodeHandle(container._scroll),
                  (x, y) => {
                      container._scroll.scrollTo({x: 0, y: y - moderateScale(40), animated: true});
                  }
              );*/
    }

    setInputText(name, text) {
        this.setState({
            [name]: text
        })
        // window['' + name] = text
        // console.log("setInputText",'' + name,text,window[name]);

    }

    onPressSelectCheckBox(item, name, check) {
        container.setState({
                /*           ['indexSelectCheckBox' + name]: check ? null : item.id,
                           ['typeSelectCheckBox' + name]: check ? null : item.type,  */

                ['indexSelectCheckBox' + name]: item.id,
                ['typeSelectCheckBox' + name]: item.type,
            },
            () => {
            })
    }

}

const styles = StyleSheet.create({
    /* container: {
         marginVertical: 5,
         borderRadius: 4,
         borderStyle: 'solid',
         borderWidth: 2,
         borderColor: Colors.green,
         backgroundColor: Colors.white,
         flex: 0,
         height: 'auto',
         overflow: 'hidden'
     },*/
    input: {
        height: moderateScale(100),
        backgroundColor: Colors.white,
        fontWeight: '600',
        fontSize: 11,
    },
    contain: {
        flex: 1,
        height: 150,
        width: "100%",
        // height: "100%",
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
    },


    /*    container: {
            paddingHorizontal: BASE_PADDING,
        },*/
    closeButton: {
        color: 'white',
        borderWidth: 1,
        borderColor: 'white',
        padding: 8,
        borderRadius: 3,
        textAlign: 'center',
        margin: 10,
        alignSelf: 'flex-end',
    },
    customHeaderBox: {
        height: 150,
        backgroundColor: '#6C7A89',
        justifyContent: 'center',
        alignItems: 'center',
    },
    /*    row: {
            flexDirection: 'row',
            marginLeft: -BASE_PADDING,
            marginRight: -BASE_PADDING,
        },*/
    col: {
        flex: 1,
    },
    square: {
        //  width: WINDOW_WIDTH ,
        // height: WINDOW_WIDTH ,
        justifyContent: 'center',
        alignSelf: 'center',
    },
    squareFirst: {
        backgroundColor: '#C0392B',
    },
    squareSecond: {
        backgroundColor: '#019875',
    },
    squareText: {
        textAlign: 'center',
        color: 'white',
    },
    /*    carousel: {
            height: WINDOW_WIDTH - BASE_PADDING * 2,
            width: WINDOW_WIDTH - BASE_PADDING * 2,
            backgroundColor: 'white',
        },
        text: {
            marginVertical: BASE_PADDING * 2,
        },*/
    stepIndicator: {
        marginVertical: moderateScale(6)
    },
    page: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
    },
    progressText: {

        paddingTop: moderateScale(50),
        fontSize: moderateScale(50),
        color: "#fff",
    },
    progressTextPlay: {
        paddingTop: moderateScale(25),
        fontSize: moderateScale(25),
        color: "#fff"
    },
    button: {
        padding: moderateScale(20)
    },
    disabledButtonText: {
        color: '#eee'
    },
    buttonText: {
        fontSize: moderateScale(20),
        color: "#fff"
    },
    activeButtonText: {
        fontSize: moderateScale(20),
        color: "#B81F00"
    }
    /* size: {
         input: moderateScale(100),
         icon: 20
     }*/
});
